import { assets } from 'common'
import { ASSETS_TYPES } from './assetsTypes'

/**
 * This object is used temporarily to store the assets info, and will be rewritten
 * on the next asset update.
 * For permanent changes refer to this google sheet:
 * https://docs.google.com/spreadsheets/d/1OfFbKDh6HE3R7WKHEJzbmtW5Kemp-I4xRe14k1WAsbo
 */
export const ASSETS_DEFINITION = {
  'BRETT/USD': {
    id: 'BRETT/USD',
    uiName: 'BRETT/USD',
    prodReady: true,
    hideInUi: false,
    hasTime: false,
    sqlDate: '2024-04-16',
    type: 'crypto',
    fiatDecimals: 6,
    uiSymbol: 'BRETT/USD',
    coinSymbol: 'BRETT',
    icon: '',
    iconPng: '',
    icon2: '',
    icon2Png: '',
    games: ['lvg-crypto'],
    color: '#5EDEFE',
    name: 'Brett',
    description:
      'Brett is a new cryptocurrency meme coin that`s loosely related to the Pepe meme. Originally conceived in the Matt Furie webcomic that created Pepe the Frog, Brett was a blue animal who was Pepe`s best friend. Brett crypto pays homage to this character by making Brett the face of its project.',
  },
  'ETHW/USD': {
    id: 'ETHW/USD',
    uiName: 'ETHW/USD',
    prodReady: true,
    hideInUi: false,
    hasTime: false,
    sqlDate: '2024-04-16',
    type: 'crypto',
    fiatDecimals: 2,
    uiSymbol: 'ETHW/USD',
    coinSymbol: 'ETHW',
    icon: '',
    iconPng: '',
    icon2: '',
    icon2Png: '',
    games: ['lvg-crypto'],
    color: '#3E5ADF',
    name: 'EthereumPoW',
    description:
      'Ethereum Proof of Work (ETHW) revolves around the Ethereum token (ETH) as transaction fuel and rewards for miners. Users pay ETH for transactions and smart contracts, while miners are rewarded with newly minted ETH and transaction fees.',
  },
  'SLERF/USD': {
    id: 'SLERF/USD',
    uiName: 'SLERF/USD',
    prodReady: true,
    hideInUi: false,
    hasTime: false,
    sqlDate: '2024-04-16',
    type: 'crypto',
    fiatDecimals: 5,
    uiSymbol: 'SLERF/USD',
    coinSymbol: 'SLERF',
    icon: '',
    iconPng: '',
    icon2: '',
    icon2Png: '',
    games: ['lvg-crypto'],
    color: '#FE8B05',
    name: 'Slerf',
    description:
      'Slerf, a sloth-themed meme coin on the Solana network, raised $10 million in a so-called presale and quickly gained popularity even though the developer mistakenly burned the liquidity provider and tokens.',
  },
  'BOME/USD': {
    id: 'BOME/USD',
    uiName: 'BOME/USD',
    prodReady: true,
    hideInUi: false,
    hasTime: false,
    sqlDate: '2024-04-16',
    type: 'crypto',
    fiatDecimals: 7,
    uiSymbol: 'BOME/USD',
    coinSymbol: 'BOME',
    icon: '',
    iconPng: '',
    icon2: '',
    icon2Png: '',
    games: ['lvg-crypto'],
    color: '#54852E',
    name: 'BOOK OF MEME',
    description:
      'TLDR. BOOK OF MEME (BOME), a new Solana-based meme coin, experienced a remarkable 5,000% price increase within a day of its launch. One trader invested 50 SOL (approximately $8,500) in the BOME presale, received 170.25 million tokens, and sold them for a profit of 717 SOL (approximately $123,000) in just 14 hours.',
  },
  'VANRY/USD': {
    id: 'VANRY/USD',
    uiName: 'VANRY/USD',
    prodReady: true,
    hideInUi: false,
    hasTime: false,
    sqlDate: '2024-04-16',
    type: 'crypto',
    fiatDecimals: 5,
    uiSymbol: 'VANRY/USD',
    coinSymbol: 'VANRY',
    icon: '',
    iconPng: '',
    icon2: '',
    icon2Png: '',
    games: ['lvg-crypto'],
    color: '#00D9B0',
    name: 'Vanar Chain',
    description:
      'VANAR Chain (formerly known as Virtua) is a carbon-neutral, high-speed, and cost-effective L1 blockchain ecosystem designed for entertainment and mainstream purposes.',
  },
  'JASMY/USD': {
    id: 'JASMY/USD',
    uiName: 'JASMY/USD',
    prodReady: true,
    hideInUi: false,
    hasTime: false,
    sqlDate: '2024-04-16',
    type: 'crypto',
    fiatDecimals: 6,
    uiSymbol: 'JASMY/USD',
    coinSymbol: 'JASMY',
    icon: '',
    iconPng: '',
    icon2: '',
    icon2Png: '',
    games: ['lvg-crypto'],
    color: '#F6921E',
    name: 'JasmyCoin',
    description:
      'JasmyCoin is based on the ERC 20 standard. The token can also be used by an unspecified number of individuals and businesses to transfer tokens using digital devices as proof of value exchange or payment for services.',
  },
  'ATOM/USD': {
    id: 'ATOM/USD',
    uiName: 'ATOM/USD',
    prodReady: true,
    hideInUi: false,
    hasTime: false,
    sqlDate: '2024-04-16',
    type: 'crypto',
    fiatDecimals: 5,
    uiSymbol: 'ATOM/USD',
    coinSymbol: 'ATOM',
    icon: '',
    iconPng: '',
    icon2: '',
    icon2Png: '',
    games: ['lvg-crypto'],
    color: '#53318A',
    name: 'Cosmos',
    description:
      'ATOM is the native token of Cosmos, a decentralized network that provides open-source tools for developers to create their own interoperable blockchains. One of the biggest problems with blockchains is they are created independently and very few have the ability to transfer data between one another.',
  },
  'NTRN/USD': {
    id: 'NTRN/USD',
    uiName: 'NTRN/USD',
    prodReady: true,
    hideInUi: false,
    hasTime: false,
    sqlDate: '2024-04-16',
    type: 'crypto',
    fiatDecimals: 5,
    uiSymbol: 'NTRN/USD',
    coinSymbol: 'NTRN',
    icon: '',
    iconPng: '',
    icon2: '',
    icon2Png: '',
    games: ['lvg-crypto'],
    color: '#000000',
    name: 'Neutron',
    description:
      'Neutron is a cross-chain smart contract platform. It enables developers to easily build cross-chain applications over Inter-Blockchain Communication Protocol (IBC) and provides dApps with the complete security of the Cosmos Hub.',
  },
  'NEAR/USD': {
    id: 'NEAR/USD',
    uiName: 'NEAR/USD',
    prodReady: true,
    hideInUi: false,
    hasTime: false,
    sqlDate: '2024-04-16',
    type: 'crypto',
    fiatDecimals: 5,
    uiSymbol: 'NEAR/USD',
    coinSymbol: 'NEAR',
    icon: '',
    iconPng: '',
    icon2: '',
    icon2Png: '',
    games: ['lvg-crypto'],
    color: '#06EC97',
    name: 'NEAR Protocol',
    description:
      'NEAR is the native token of the NEAR Protocol, a highly scalable blockchain network that provides a developer-friendly, decentralized application platform. NEAR tokens are used to pay network fees and can be staked to enhance network security.',
  },
  'TAO/USD': {
    id: 'TAO/USD',
    uiName: 'TAO/USD',
    prodReady: true,
    hideInUi: false,
    hasTime: false,
    sqlDate: '2024-04-16',
    type: 'crypto',
    fiatDecimals: 3,
    uiSymbol: 'TAO/USD',
    coinSymbol: 'TAO',
    icon: '',
    iconPng: '',
    icon2: '',
    icon2Png: '',
    games: ['lvg-crypto'],
    color: '#000000',
    name: 'Bittensor USD',
    description:
      'Bittensor (TAO) is an open-source protocol that powers a decentralized, blockchain-based machine-learning network. TAO is the native cryptocurrency for Bittensor and it is rewarded to machine learning models that train collaboratively and according to the informational value they offer the collective.',
  },
  'MANTA/USD': {
    id: 'MANTA/USD',
    uiName: 'MANTA/USD',
    prodReady: true,
    hideInUi: false,
    hasTime: false,
    sqlDate: '2024-04-16',
    type: 'crypto',
    fiatDecimals: 5,
    uiSymbol: 'MANTA/USD',
    coinSymbol: 'MANTA',
    icon: '',
    iconPng: '',
    icon2: '',
    icon2Png: '',
    games: ['lvg-crypto'],
    color: '#1F6EF8',
    name: 'Manta Network',
    description:
      'Manta Pacific is an EVM-compatible network that offers support for decentralized applications and uses Celestia for data availability (technically making it a validium). Built using the OP Stack, Manta Pacific currently has $1.7 billion of value in its smart contracts, falling behind Arbitrum and Optimism.',
  },
  'CFX/USD': {
    id: 'CFX/USD',
    uiName: 'CFX/USD',
    prodReady: true,
    hideInUi: false,
    hasTime: false,
    sqlDate: '2024-04-16',
    type: 'crypto',
    fiatDecimals: 5,
    uiSymbol: 'CFX/USD',
    coinSymbol: 'CFX',
    icon: '',
    iconPng: '',
    icon2: '',
    icon2Png: '',
    games: ['lvg-crypto'],
    color: '#1E1E2C',
    name: 'Conflux Network',
    description:
      "Conflux Network (CFX) is a high-performance layer 1 blockchain that uses the proof-of-work consensus with proof-of-stake finality. It's built out of China and it's a regulatory-compliant blockchain in the country, which is why Conflux Network is called the “Chinese Ethereum”.",
  },
  'ONDO/USD': {
    id: 'ONDO/USD',
    uiName: 'ONDO/USD',
    prodReady: true,
    hideInUi: false,
    hasTime: false,
    sqlDate: '2024-04-16',
    type: 'crypto',
    fiatDecimals: 5,
    uiSymbol: 'ONDO/USD',
    coinSymbol: 'ONDO',
    icon: '',
    iconPng: '',
    icon2: '',
    icon2Png: '',
    games: ['lvg-crypto'],
    color: '#1F4480',
    name: 'ONDO',
    description:
      'Ondo Finance is a decentralized finance (DeFi) protocol that aims to provide institutional-grade liquidity solutions for tokenized real-world assets. It launched its coin ONDO on January 18, 2024. It debuted with a value of $0.10, skyrocketing in a few days but pulling back a bit after that.',
  },
  'PENDLE/USD': {
    id: 'PENDLE/USD',
    uiName: 'PENDLE/USD',
    prodReady: true,
    hideInUi: false,
    hasTime: false,
    sqlDate: '2024-04-16',
    type: 'crypto',
    fiatDecimals: 5,
    uiSymbol: 'PENDLE/USD',
    coinSymbol: 'PENDLE',
    icon: '',
    iconPng: '',
    icon2: '',
    icon2Png: '',
    games: ['lvg-crypto'],
    color: '#1F4480',
    name: 'PENDLE',
    description:
      'Pendle is a protocol that enables the tokenization and trading of future yield. With the creation of a novel AMM that supports assets with time decay, Pendle gives users more control over future yield by providing optionality and opportunities for its utilization.',
  },
  'WIF/USD': {
    id: 'WIF/USD',
    uiName: 'WIF/USD',
    prodReady: true,
    hideInUi: false,
    hasTime: false,
    sqlDate: '2024-04-16',
    type: 'crypto',
    fiatDecimals: 5,
    uiSymbol: 'WIF/USD',
    coinSymbol: 'WIF',
    icon: '',
    iconPng: '',
    icon2: '',
    icon2Png: '',
    games: ['lvg-crypto'],
    color: '#F2B191',
    name: 'Dogwifhat',
    description:
      'Dogwifhat (WIF) is a cryptocurrency that operates on the Solana blockchain. It draws inspiration from the Dogwifhat meme and is categorized alongside other dog-themed tokens like BONK, all of which have gained popularity in the community recently.',
  },
  'IMX/USD': {
    id: 'IMX/USD',
    uiName: 'IMX/USD',
    prodReady: true,
    hideInUi: false,
    hasTime: false,
    sqlDate: '2024-04-16',
    type: 'crypto',
    fiatDecimals: 5,
    uiSymbol: 'IMX/USD',
    coinSymbol: 'IMX',
    icon: '',
    iconPng: '',
    icon2: '',
    icon2Png: '',
    games: ['lvg-crypto'],
    color: '#1AA29B',
    name: 'Impermax',
    description:
      'Impermax is an automated crypto lending platform that allows users to use their liquidity provider tokens as collateral for permissionless loans. LP tokens are the coins allocated to liquidity providers on a (DEX) decentralized exchange.',
  },
  'SUI/USD': {
    id: 'SUI/USD',
    uiName: 'SUI/USD',
    prodReady: true,
    hideInUi: false,
    hasTime: false,
    sqlDate: '2024-04-16',
    type: 'crypto',
    fiatDecimals: 5,
    uiSymbol: 'SUI/USD',
    coinSymbol: 'SUI',
    icon: '',
    iconPng: '',
    icon2: '',
    icon2Png: '',
    games: ['lvg-crypto'],
    color: '#6DA5D9',
    name: 'Sui',
    description:
      'SUI Blockchain is a decentralized digital ledger that revolutionizes data storage with object-centric design, enabling gasless transactions and unparalleled composability. It redefines how we interact with Web3 technology.',
  },
  'CYBER/USD': {
    id: 'CYBER/USD',
    uiName: 'CYBER/USD',
    prodReady: true,
    hideInUi: false,
    hasTime: false,
    sqlDate: '2024-04-16',
    type: 'crypto',
    fiatDecimals: 5,
    uiSymbol: 'CYBER/USD',
    coinSymbol: 'CYBER',
    icon: '',
    iconPng: '',
    icon2: '',
    icon2Png: '',
    games: ['lvg-crypto'],
    color: '#000000',
    name: 'Cyberpunk City',
    description:
      'Cyberpunk City is a play-to-earn blockchain massively multiplayer online role-playing game metaverse where players can own NFT characters and earn CYBER tokens on the Elrond network.',
  },
  'SEI/USD': {
    id: 'SEI/USD',
    uiName: 'SEI/USD',
    prodReady: true,
    hideInUi: false,
    hasTime: false,
    sqlDate: '2024-04-16',
    type: 'crypto',
    fiatDecimals: 5,
    uiSymbol: 'SEI/USD',
    coinSymbol: 'SEI',
    icon: '',
    iconPng: '',
    icon2: '',
    icon2Png: '',
    games: ['lvg-crypto'],
    color: '#B4354B',
    name: 'Sei',
    description:
      'Sei is a general purpose, open-source Layer 1 blockchain specialized for the exchange of digital assets. Leveraging a novel consensus and technical breakthroughs, Sei is the fastest blockchain in the industry. A common misconception is that Sei is a DeFi chain.',
  },
  '1000BONK/USD': {
    id: '1000BONK/USD',
    uiName: '1000BONK/USD',
    prodReady: true,
    hideInUi: false,
    hasTime: false,
    sqlDate: '2024-04-16',
    type: 'crypto',
    fiatDecimals: 7,
    uiSymbol: '1000BONK/USD',
    coinSymbol: '1000BONK',
    icon: '',
    iconPng: '',
    icon2: '',
    icon2Png: '',
    games: ['lvg-crypto'],
    color: '#F38D00',
    name: 'Bonk',
    description:
      "BONK is the very first Dog-themed memecoin on Solana that's “for the people, by the people.” The document states: The BONK contributors were tired of toxic “Alameda” tokenomics and wanted to make a fun memecoin where everyone gets a fair shot.",
  },
  'WLD/USD': {
    id: 'WLD/USD',
    uiName: 'WLD/USD',
    prodReady: true,
    hideInUi: false,
    hasTime: false,
    sqlDate: '2024-04-16',
    type: 'crypto',
    fiatDecimals: 3,
    uiSymbol: 'WLD/USD',
    coinSymbol: 'WLD',
    icon: '',
    iconPng: '',
    icon2: '',
    icon2Png: '',
    games: ['lvg-crypto'],
    color: '#000000',
    name: 'Worldcoin',
    description:
      "Worldcoin, the ambitious cryptocurrency and digital ID project spearheaded by OpenAI chief Sam Altman, launched on Monday after years in development, promising to verify users' identity by scanning their eyes and potentially solving one of the more pressing problems posed by recent advances in artificial intelligence.",
  },
  'BCH/USD': {
    id: 'BCH/USD',
    uiName: 'BCH/USD',
    prodReady: true,
    hideInUi: false,
    hasTime: false,
    sqlDate: '2024-04-16',
    type: 'crypto',
    fiatDecimals: 5,
    uiSymbol: 'BCH/USD',
    coinSymbol: 'BCH',
    icon: '',
    iconPng: '',
    icon2: '',
    icon2Png: '',
    games: ['lvg-crypto'],
    color: '#0CC18D',
    name: 'Bitcoin Cash',
    description:
      'Bitcoin Cash (BCH) is an altcoin version of the popular Bitcoin cryptocurrency. Bitcoin Cash is the result of a hard fork in blockchain technology. One of the most significant changes from Bitcoin to Bitcoin Cash is the size of the coin.',
  },
  'KNC/USD': {
    id: 'KNC/USD',
    uiName: 'KNC/USD',
    prodReady: true,
    hideInUi: false,
    hasTime: false,
    sqlDate: '2024-04-16',
    type: 'crypto',
    fiatDecimals: 5,
    uiSymbol: 'KNC/USD',
    coinSymbol: 'KNC',
    icon: '',
    iconPng: '',
    icon2: '',
    icon2Png: '',
    games: ['lvg-crypto'],
    color: '#2EC38C',
    name: 'Kyber',
    description: '',
  },
  'KDA/USD': {
    id: 'KDA/USD',
    uiName: 'KDA/USD',
    prodReady: true,
    hideInUi: false,
    hasTime: false,
    sqlDate: '2024-04-16',
    type: 'crypto',
    fiatDecimals: 6,
    uiSymbol: 'KDA/USD',
    coinSymbol: 'KDA',
    icon: '',
    iconPng: '',
    icon2: '',
    icon2Png: '',
    games: ['lvg-crypto'],
    color: '#69009A',
    name: 'Kadena',
    description:
      'Kadena (KDA) is a digital currency that is used to pay for compute on the Kadena public chain. Similar to ETH on Ethereum, KDA on Kadena is the manner by which miners are compensated for mining blocks on the network and is the transaction fee that users pay in order to have their transactions included in a block.',
  },
  'BLUR/USD': {
    id: 'BLUR/USD',
    uiName: 'BLUR/USD',
    prodReady: true,
    hideInUi: false,
    hasTime: false,
    sqlDate: '2024-04-16',
    type: 'crypto',
    fiatDecimals: 3,
    uiSymbol: 'BLUR/USD',
    coinSymbol: 'BLUR',
    icon: '',
    iconPng: '',
    icon2: '',
    icon2Png: '',
    games: ['lvg-crypto'],
    color: '#F36925',
    name: 'Blur',
    description:
      'Blur (BLUR) is an Ethereum-based digital marketplace that stands out among other platforms in the NFT market. It is a marketplace aggregator and offers advanced analytics, excellent portfolio management capabilities, and the ability to compare NFTs on multiple marketplaces.',
  },
  'FTM/USD': {
    id: 'FTM/USD',
    uiName: 'FTM/USD',
    prodReady: true,
    hideInUi: true,
    hasTime: false,
    sqlDate: '2024-04-16',
    type: 'crypto',
    fiatDecimals: 5,
    uiSymbol: 'FTM/USD',
    coinSymbol: 'FTM',
    icon: '',
    iconPng: '',
    icon2: '',
    icon2Png: '',
    games: ['lvg-crypto'],
    color: '#1869FF',
    name: 'Fantom',
    description:
      'Fantom (FTM) is a decentralized, permissionless, open-source smart contract platform for decentralized applications (dApps) and digital assets — one of many blockchain networks built to provide an alternative to Ethereum.',
  },
  'AAVE/USD': {
    id: 'AAVE/USD',
    uiName: 'AAVE/USD',
    prodReady: true,
    hideInUi: false,
    hasTime: false,
    sqlDate: '2024-04-16',
    type: 'crypto',
    fiatDecimals: 5,
    uiSymbol: 'AAVE/USD',
    coinSymbol: 'AAVE',
    icon: '',
    iconPng: '',
    icon2: '',
    icon2Png: '',
    games: ['lvg-crypto'],
    color: '#49A5BD',
    name: 'Aave',
    description:
      'Aave (AAVE) is a decentralized crypto lending platform that lets users borrow and lend crypto. Aave uses smart contracts to automate the process. It specializes in overcollateralized loans that require users to deposit crypto worth more than the amount that they wish to borrow.',
  },
  'COMP/USD': {
    id: 'COMP/USD',
    uiName: 'COMP/USD',
    prodReady: true,
    hideInUi: true,
    hasTime: false,
    sqlDate: '2024-04-16',
    type: 'crypto',
    fiatDecimals: 5,
    uiSymbol: 'COMP/USD',
    coinSymbol: 'COMP',
    icon: '',
    iconPng: '',
    icon2: '',
    icon2Png: '',
    games: ['lvg-crypto'],
    color: '#00D396',
    name: 'Compound',
    description:
      'Compound (COMP) allows users to deposit cryptocurrency into lending pools for access by borrowers. Lenders then earn interest on the assets they deposit. Once a deposit is made, Compound awards a new cryptocurrency called a cToken (which represents the deposit) to the lender.',
  },
  'UNI/USD': {
    id: 'UNI/USD',
    uiName: 'UNI/USD',
    prodReady: true,
    hideInUi: false,
    hasTime: false,
    sqlDate: '2024-04-16',
    type: 'crypto',
    fiatDecimals: 5,
    uiSymbol: 'UNI/USD',
    coinSymbol: 'UNI',
    icon: '',
    iconPng: '',
    icon2: '',
    icon2Png: '',
    games: ['lvg-crypto'],
    color: '#FF007A',
    name: 'Uniswap',
    description:
      "Uniswap (UNI) is an Ethereum token that powers Uniswap, an automated liquidity provider that's designed to make it easy to exchange Ethereum (ERC-20) tokens. There is no orderbook or central facilitator on Uniswap. Instead, tokens are exchanged through liquidity pools that are defined by smart contracts.",
  },
  'SUSHI/USD': {
    id: 'SUSHI/USD',
    uiName: 'SUSHI/USD',
    prodReady: true,
    hideInUi: true,
    hasTime: false,
    sqlDate: '2024-04-16',
    type: 'crypto',
    fiatDecimals: 5,
    uiSymbol: 'SUSHI/USD',
    coinSymbol: 'SUSHI',
    icon: '',
    iconPng: '',
    icon2: '',
    icon2Png: '',
    games: ['lvg-crypto'],
    color: '#FA52A0',
    name: 'SushiSwap',
    description:
      "SushiSwap (SUSHI) is an Ethereum token that powers SushiSwap, a decentralized cryptocurrency exchange and automated market maker built on Ethereum. Holders of SUSHI can participate in community governance and stake their tokens to receive a portion of SushiSwap's transaction fees.",
  },
  'DASH/USD': {
    id: 'DASH/USD',
    uiName: 'DASH/USD',
    prodReady: true,
    hideInUi: true,
    hasTime: false,
    sqlDate: '2024-04-16',
    type: 'crypto',
    fiatDecimals: 5,
    uiSymbol: 'DASH/USD',
    coinSymbol: 'DASH',
    icon: '',
    iconPng: '',
    icon2: '',
    icon2Png: '',
    games: ['lvg-crypto'],
    color: '#008DE4',
    name: 'Dash',
    description:
      'Dash (DASH) is an open source cryptocurrency. It is an altcoin that was forked from the Bitcoin protocol. It is also a decentralized autonomous organization (DAO) run by a subset of its users, which are called "masternodes".',
  },
  'ZRX/USD': {
    id: 'ZRX/USD',
    uiName: 'ZRX/USD',
    prodReady: true,
    hideInUi: true,
    hasTime: false,
    sqlDate: '2024-04-16',
    type: 'crypto',
    fiatDecimals: 5,
    uiSymbol: 'ZRX/USD',
    coinSymbol: 'ZRX',
    icon: '',
    iconPng: '',
    icon2: '',
    icon2Png: '',
    games: ['lvg-crypto'],
    color: '#000000',
    name: '0x Protocol',
    description:
      "0x Protocol (ZRX) is a peer-to-peer exchange of Ethereum-based tokens. It is often referred to as a decentralized exchange. State channels take transactions offline, thereby reducing costs that are incurred if the transactions take place on Ethereum's network.",
  },
  'BAND/USD': {
    id: 'BAND/USD',
    uiName: 'BAND/USD',
    prodReady: true,
    hideInUi: true,
    hasTime: false,
    sqlDate: '2024-04-16',
    type: 'crypto',
    fiatDecimals: 5,
    uiSymbol: 'BAND/USD',
    coinSymbol: 'BAND',
    icon: '',
    iconPng: '',
    icon2: '',
    icon2Png: '',
    games: ['lvg-crypto'],
    color: '#451FE6',
    name: 'Band Protocol',
    description:
      'Band Protocol (BAND) is used as collateral by nodes that verify the real-world data that is sent to various blockchains. Nodes fall into two categories: validators and delegators. This two-node structure is common among Cosmos-based Delegated Proof-of-Stake (DPoS) blockchains.',
  },
  'ENS/USD': {
    id: 'ENS/USD',
    uiName: 'ENS/USD',
    prodReady: true,
    hideInUi: true,
    hasTime: false,
    sqlDate: '2024-04-16',
    type: 'crypto',
    fiatDecimals: 5,
    uiSymbol: 'ENS/USD',
    coinSymbol: 'ENS',
    icon: '',
    iconPng: '',
    icon2: '',
    icon2Png: '',
    games: ['lvg-crypto'],
    color: '#5173FF',
    name: 'Ethereum Name Service',
    description:
      'Ethereum Name Service (ENS) is an ERC-20 utility token associated with the Ethereum Name Service, a decentralized naming system built on the Ethereum network. The ENS token was issued via an airdrop to all ENS domain holders, ENS contributors, and the ENS DAO community treasury.',
  },
  'AVAX/USD': {
    id: 'AVAX/USD',
    uiName: 'AVAX/USD',
    prodReady: true,
    hideInUi: false,
    hasTime: false,
    sqlDate: '2024-04-16',
    type: 'crypto',
    fiatDecimals: 5,
    uiSymbol: 'AVAX/USD',
    coinSymbol: 'AVAX',
    icon: '',
    iconPng: '',
    icon2: '',
    icon2Png: '',
    games: ['lvg-crypto'],
    color: '#E84143',
    name: 'Avalanche',
    description:
      'Avalanche (AVAX) is a cryptocurrency and blockchain platform that rivals Ethereum. AVAX is the native token of the Avalanche blockchain, which—like Ethereum—uses smart contracts to support a variety of blockchain projects. The Avalanche blockchain can provide near-instant transaction finality.',
  },
  'LTC/USD': {
    id: 'LTC/USD',
    uiName: 'LTC/USD',
    prodReady: true,
    hideInUi: false,
    hasTime: false,
    sqlDate: '2024-04-16',
    type: 'crypto',
    fiatDecimals: 5,
    uiSymbol: 'LTC/USD',
    coinSymbol: 'LTC',
    icon: '',
    iconPng: '',
    icon2: '',
    icon2Png: '',
    games: ['lvg-crypto'],
    color: '#4534FF',
    name: 'Litecoin',
    description:
      'Widely considered as the first successful altcoin, Litecoin’s 2011 release inspired countless developers to try to expand the crypto user base by altering Bitcoin’s code and utilizing it to launch different networks. While Litecoin was not the first cryptocurrency to copy Bitcoin’s code and alter its features, it is one of the most significant ones (historically speaking).',
  },
  'LINK/USD': {
    id: 'LINK/USD',
    uiName: 'LINK/USD',
    prodReady: true,
    hideInUi: false,
    hasTime: false,
    sqlDate: '2024-04-16',
    type: 'crypto',
    fiatDecimals: 5,
    uiSymbol: 'LINK/USD',
    coinSymbol: 'LINK',
    icon: '',
    iconPng: '',
    icon2: '',
    icon2Png: '',
    games: ['lvg-crypto'],
    color: '#2A5ADA',
    name: 'Chainlink',
    description:
      'Chainlink (LINK) is a cryptocurrency and technology platform that enables non-blockchain enterprises to securely connect with blockchain platforms. Chainlink is middleware that connects blockchain-based smart contracts with external data, such as baseball scores or stock prices.',
  },
  'ADA/USD': {
    id: 'ADA/USD',
    uiName: 'ADA/USD',
    prodReady: true,
    hideInUi: false,
    hasTime: false,
    sqlDate: '2024-04-16',
    type: 'crypto',
    fiatDecimals: 5,
    uiSymbol: 'ADA/USD',
    coinSymbol: 'ADA',
    icon: '',
    iconPng: '',
    icon2: '',
    icon2Png: '',
    games: ['lvg-crypto'],
    color: '#0033AD',
    name: 'Cardano',
    description:
      'Cardano (ADA) is a Proof of Stake (PoS) general purpose blockchain project. Known as a “third-generation” blockchain, Cardano has set about solving the common scalability issues plaguing most “second-gen” blockchains (such as Ethereum and it’s ever-increasing gas fees).',
  },
  'TRX/USD': {
    id: 'TRX/USD',
    uiName: 'TRX/USD',
    prodReady: true,
    hideInUi: false,
    hasTime: false,
    sqlDate: '2024-04-16',
    type: 'crypto',
    fiatDecimals: 5,
    uiSymbol: 'TRX/USD',
    coinSymbol: 'TRX',
    icon: '',
    iconPng: '',
    icon2: '',
    icon2Png: '',
    games: ['lvg-crypto'],
    color: '#FF060A',
    name: 'TRON',
    description:
      'Tron is a blockchain-based decentralized digital platform with its own cryptocurrency, called Tronix or TRX. Founded in 2017 by a Singapore non-profit organization, the Tron Foundation, Tron aims to host a global entertainment system for the cost-effective sharing of digital content.',
  },
  'DOT/USD': {
    id: 'DOT/USD',
    uiName: 'DOT/USD',
    prodReady: true,
    hideInUi: false,
    hasTime: false,
    sqlDate: '2024-04-16',
    type: 'crypto',
    fiatDecimals: 5,
    uiSymbol: 'DOT/USD',
    coinSymbol: 'DOT',
    icon: '',
    iconPng: '',
    icon2: '',
    icon2Png: '',
    games: ['lvg-crypto'],
    color: '#E6007B',
    name: 'Polkadot',
    description:
      'Polkadot (DOT) is a cryptocurrency . Polkadot has a current supply of 1,283,028,042.0238583 with 1,156,604,371.7186785 in circulation.',
  },
  'MATIC/USD': {
    id: 'MATIC/USD',
    uiName: 'MATIC/USD',
    prodReady: true,
    hideInUi: false,
    hasTime: false,
    sqlDate: '2024-04-16',
    type: 'crypto',
    fiatDecimals: 5,
    uiSymbol: 'MATIC/USD',
    coinSymbol: 'MATIC',
    icon: '',
    iconPng: '',
    icon2: '',
    icon2Png: '',
    games: ['lvg-crypto'],
    color: '#8247E5',
    name: 'Polygon',
    description:
      "MATIC is Polygon's native cryptocurrency. It is an ERC-20 token, a token created on the Ethereum blockchain. This token is used to govern and secure the Polygon network and pay the network's transaction fees.",
  },
  'APE/USD': {
    id: 'APE/USD',
    uiName: 'APE/USD',
    prodReady: true,
    hideInUi: false,
    hasTime: false,
    sqlDate: '2024-04-16',
    type: 'crypto',
    fiatDecimals: 5,
    uiSymbol: 'APE/USD',
    coinSymbol: 'APE',
    icon: '',
    iconPng: '',
    icon2: '',
    icon2Png: '',
    games: ['lvg-crypto'],
    color: '#0052F1',
    name: 'ApeCoin',
    description:
      'ApeCoin (APE) is a cryptocurrency intended to support the development of a decentralized web3, inspired by one of the most famous and valuable NFT collections: the Bored Ape Yacht Club. APE is a fungible, ERC-20 token built on the Ethereum blockchain.',
  },
  'ARB/USD': {
    id: 'ARB/USD',
    uiName: 'ARB/USD',
    prodReady: true,
    hideInUi: false,
    hasTime: false,
    sqlDate: '2024-04-16',
    type: 'crypto',
    fiatDecimals: 5,
    uiSymbol: 'ARB/USD',
    coinSymbol: 'ARB',
    icon: '',
    iconPng: '',
    icon2: '',
    icon2Png: '',
    games: ['lvg-crypto'],
    color: '#26A0F0',
    name: 'Arbitrum',
    description:
      'Arbitrum (ARB) is a technology suite designed to scale Ethereum. You can use Arbitrum chains to do all things you do on Ethereum — use Web3 apps, deploy smart contracts, etc., but your transactions will be cheaper and faster.',
  },
  'MEME/USD': {
    id: 'MEME/USD',
    uiName: 'MEME/USD',
    prodReady: true,
    hideInUi: false,
    hasTime: false,
    sqlDate: '2024-04-16',
    type: 'crypto',
    fiatDecimals: 3,
    uiSymbol: 'MEME/USD',
    coinSymbol: 'MEME',
    icon: '',
    iconPng: '',
    icon2: '',
    icon2Png: '',
    games: ['lvg-crypto'],
    color: '#4B7B4D',
    name: 'Memetic/PepeCoin',
    description:
      'Memetic / PepeCoin is an open-source peer-to-peer cryptocurrency, usually shortened as its ticker name MEME. It belongs to the subdivision of memecoins, which are based on funny viral images on the Internet. Some notorious examples of such coins include Dogecoin.',
  },
  'BOME/USD': {
    id: 'BOME/USD',
    uiName: 'BOME/USD',
    prodReady: true,
    hideInUi: false,
    hasTime: false,
    sqlDate: '3/15/2024',
    type: ASSETS_TYPES.CRYPTO,
    fiatDecimals: 7,
    uiSymbol: 'BOME/USD',
    coinSymbol: 'BOME',
    icon: assets.bome_icon,
    iconPng: assets.bome_icon_png,
    icon2: '',
    icon2Png: '',
    games: ['lvg-crypto', 'axe-cap'],
    color: '#54852E',
    name: 'BOOK OF MEME',
    description:
      'TLDR. BOOK OF MEME (BOME), a new Solana-based meme coin, experienced a remarkable 5,000% price increase within a day of its launch. One trader invested 50 SOL (approximately $8,500) in the BOME presale, received 170.25 million tokens, and sold them for a profit of 717 SOL (approximately $123,000) in just 14 hours.',
  },
  'VANRY/USD': {
    id: 'VANRY/USD',
    uiName: 'VANRY/USD',
    prodReady: true,
    hideInUi: false,
    hasTime: false,
    sqlDate: '3/14/2024',
    type: ASSETS_TYPES.CRYPTO,
    fiatDecimals: 5,
    uiSymbol: 'VANRY/USD',
    coinSymbol: 'VANRY',
    icon: assets.vanry_icon,
    iconPng: assets.vanry_icon_png,
    icon2: '',
    icon2Png: '',
    games: ['lvg-crypto', 'axe-cap'],
    color: '#00D9B0',
    name: 'Vanar Chain',
    description:
      'VANAR Chain (formerly known as Virtua) is a carbon-neutral, high-speed, and cost-effective L1 blockchain ecosystem designed for entertainment and mainstream purposes.',
  },
  'FIL/USD': {
    id: 'FIL/USD',
    uiName: 'FIL/USD',
    prodReady: true,
    hideInUi: false,
    hasTime: false,
    sqlDate: '3/14/2024',
    type: ASSETS_TYPES.CRYPTO,
    fiatDecimals: 4,
    uiSymbol: 'FIL/USD',
    coinSymbol: 'FIL',
    icon: assets.fil_icon,
    iconPng: assets.fil_icon_png,
    icon2: '',
    icon2Png: '',
    games: ['lvg-crypto', 'axe-cap'],
    color: '#0191FF',
    name: 'Filecoin',
    description:
      'What is Filecoin ? The FilECOIN (fil) cryptocurrency and payment system is built on the blockchain. InterPlanetary File System is used by Protocol Labs and allows customers to rent out idle, hard drive space. The transactions are recorded using a blockchain system.',
  },
  'PORTAL/USD': {
    id: 'PORTAL/USD',
    uiName: 'PORTAL/USD',
    prodReady: true,
    hideInUi: false,
    hasTime: false,
    sqlDate: '3/14/2024',
    type: ASSETS_TYPES.CRYPTO,
    fiatDecimals: 5,
    uiSymbol: 'PORTAL/USD',
    coinSymbol: 'PORTAL',
    icon: assets.portal_icon,
    iconPng: assets.portal_icon_png,
    icon2: '',
    icon2Png: '',
    games: ['lvg-crypto', 'axe-cap'],
    color: '#FF00FE',
    name: 'Portal',
    description:
      'What is Portal? Portal is a Bitcoin-based cross-chain atomic swaps protocol. Its two main products are a decentralized exchange and a wallet. Portal DEX enables Layer 2 atomic swaps of cryptocurrencies across blockchains.',
  },
  'FET/USD': {
    id: 'FET/USD',
    uiName: 'FET/USD',
    prodReady: true,
    hideInUi: false,
    hasTime: false,
    sqlDate: '2/22/2024',
    type: ASSETS_TYPES.CRYPTO,
    fiatDecimals: 5,
    uiSymbol: 'FET/USD',
    coinSymbol: 'FET',
    icon: assets.fet_icon,
    iconPng: assets.fet_icon_png,
    icon2: '',
    icon2Png: '',
    games: ['lvg-crypto', 'axe-cap'],
    color: '#000D3D',
    name: 'Fetch.ai',
    description:
      "Fetch AI (FET) is an Ethereum token that powers Fetch.ai, a decentralized machine learning platform for applications such as asset trading, gig economy work, and energy grid optimization. Fetch. ai's first decentralized finance application helps Uniswap users automate trading according to predefined conditions.",
  },
  'JASMY/USD': {
    id: 'JASMY/USD',
    uiName: 'JASMY/USD',
    prodReady: true,
    hideInUi: false,
    hasTime: false,
    sqlDate: '2/22/2024',
    type: ASSETS_TYPES.CRYPTO,
    fiatDecimals: 6,
    uiSymbol: 'JASMY/USD',
    coinSymbol: 'JASMY',
    icon: assets.jasmy_icon,
    iconPng: assets.jasmy_icon_png,
    icon2: '',
    icon2Png: '',
    games: ['lvg-crypto', 'axe-cap'],
    color: '#F6921E',
    name: 'JasmyCoin',
    description:
      'JasmyCoin is based on the ERC  20 standard. The token can also be used by an unspecified number of individuals and businesses to transfer tokens using digital devices as proof of value exchange or payment for services.',
  },
  'AGIX/USD': {
    id: 'AGIX/USD',
    uiName: 'AGIX/USD',
    prodReady: true,
    hideInUi: false,
    hasTime: false,
    sqlDate: '2/22/2024',
    type: ASSETS_TYPES.CRYPTO,
    fiatDecimals: 6,
    uiSymbol: 'AGIX/USD',
    coinSymbol: 'AGIX',
    icon: assets.agix_icon,
    iconPng: assets.agix_icon_png,
    icon2: '',
    icon2Png: '',
    games: ['lvg-crypto', 'axe-cap'],
    color: '#801BA4',
    name: 'SingularityNET',
    description:
      'SingularityNET (AGIX) is a decentralized Artificial Intelligence (AI) platform based on two leading smart contract blockchains — Ethereum (ETH) and Cardano (ADA). The platform lets anyone create, share, promote and monetize AI products and services.',
  },
  ARM: {
    id: 'ARM',
    uiName: 'xARM',
    prodReady: true,
    hideInUi: false,
    hasTime: false,
    sqlDate: '2/22/2024',
    type: ASSETS_TYPES.STOCKS,
    fiatDecimals: 2,
    uiSymbol: 'xARM',
    coinSymbol: 'xARM',
    icon: assets.arm_icon,
    iconPng: assets.arm_icon_png,
    icon2: '',
    icon2Png: '',
    games: ['lvg-crypto', 'axe-cap'],
    color: '#0091BD',
    name: 'Arm Holdings plc',
    description:
      'Arm Holdings plc architects, develops, and licenses central processing unit products and related technologies for semiconductor companies and original equipment manufacturers rely on to develop products. It offers microprocessors, systems intellectual property (IPs), graphics processing units, physical IP and associated systems IPs, software, tools, and other related services.',
  },
  'ZETA/USD': {
    id: 'ZETA/USD',
    uiName: 'ZETA/USD',
    prodReady: true,
    hideInUi: false,
    hasTime: false,
    sqlDate: '2/15/2024',
    type: ASSETS_TYPES.CRYPTO,
    fiatDecimals: 5,
    uiSymbol: 'ZETA/USD',
    coinSymbol: 'ZETA',
    icon: assets.zeta_icon,
    iconPng: assets.zeta_icon_png,
    icon2: '',
    icon2Png: '',
    games: ['lvg-crypto', 'axe-cap'],
    color: '#004B39',
    name: 'ZetaChain',
    description:
      'ZetaChain is a blockchain that connects everything. It enables interoperability between any blockchains or layers by providing cross-chain value transfer and message delivery, as well as native omnichain smart contract support.',
  },
  'ATOM/USD': {
    id: 'ATOM/USD',
    uiName: 'ATOM/USD',
    prodReady: true,
    hideInUi: false,
    hasTime: false,
    sqlDate: '2/15/2024',
    type: ASSETS_TYPES.CRYPTO,
    fiatDecimals: 5,
    uiSymbol: 'ATOM/USD',
    coinSymbol: 'ATOM',
    icon: assets.atom_icon,
    iconPng: assets.atom_icon_png,
    icon2: '',
    icon2Png: '',
    games: ['lvg-crypto', 'axe-cap'],
    color: '#53318A',
    name: 'Cosmos',
    description:
      'ATOM is the native token of Cosmos, a decentralized network that provides open-source tools for developers to create their own interoperable blockchains. One of the biggest problems with blockchains is they are created independently and very few have the ability to transfer data between one another.',
  },
  'NTRN/USD': {
    id: 'NTRN/USD',
    uiName: 'NTRN/USD',
    prodReady: true,
    hideInUi: false,
    hasTime: false,
    sqlDate: '2/15/2024',
    type: ASSETS_TYPES.CRYPTO,
    fiatDecimals: 5,
    uiSymbol: 'NTRN/USD',
    coinSymbol: 'NTRN',
    icon: assets.ntrn_icon,
    iconPng: assets.ntrn_icon_png,
    icon2: '',
    icon2Png: '',
    games: ['lvg-crypto', 'axe-cap'],
    color: '#000000',
    name: 'Neutron',
    description:
      'Neutron is a cross-chain smart contract platform. It enables developers to easily build cross-chain applications over Inter-Blockchain Communication Protocol (IBC) and provides dApps with the complete security of the Cosmos Hub.',
  },
  'DYM/USD': {
    id: 'DYM/USD',
    uiName: 'DYM/USD',
    prodReady: true,
    hideInUi: false,
    hasTime: false,
    sqlDate: '2/8/2024',
    coinSymbol: 'DYM',
    fiatDecimals: 5,
    type: ASSETS_TYPES.CRYPTO,
    icon: assets.dym_icon,
    iconPng: assets.dym_icon_png,
    icon2: '',
    icon2Png: '',
    color: '#1C1818',
    games: ['lvg-crypto', 'axe-cap'],
    name: 'Dymension',
    description:
      'Dymension is a so-termed modular settlement layer that provides all the tools and infrastructure needed to easily launch “rollApps” – a portmanteau of "rollup," denoting a type of layer-2 blockchain, and "dApp," which is a decentralized application.',
  },
  'PORK/USD': {
    id: 'PORK/USD',
    uiName: 'PORK/USD',
    prodReady: true,
    hideInUi: false,
    hasTime: false,
    sqlDate: '2/2/2024',
    coinSymbol: 'PORK',
    fiatDecimals: 10,
    type: ASSETS_TYPES.CRYPTO,
    icon: assets.pork_icon,
    iconPng: assets.pork_icon_png,
    icon2: '',
    icon2Png: '',
    color: '#FE98D9',
    games: ['lvg-crypto', 'axe-cap'],
    name: 'PepeFork (Experimental)',
    description:
      'Pepe Coin, from which $PORK derives its roots, gained widespread recognition as a viral Ethereum-based meme token during the meme frenzy of the first half of 2023. This phenomenon transformed crypto speculators into overnight millionaires, showcasing the power of community-driven projects.',
  },
  'JUP/USD': {
    id: 'JUP/USD',
    uiName: 'JUP/USD',
    prodReady: true,
    hideInUi: false,
    hasTime: false,
    sqlDate: '1/31/2024',
    coinSymbol: 'JUP',
    fiatDecimals: 5,
    type: ASSETS_TYPES.CRYPTO,
    icon: assets.jup_icon,
    iconPng: assets.jup_icon_png,
    icon2: '',
    icon2Png: '',
    color: '#BAF47C',
    games: ['lvg-crypto', 'axe-cap'],
    name: 'Jupiter',
    description:
      "Jupiter is a DEX aggregator on Solana that routes over 80% of all DEX trades! It's an absolute killer app that has served as the entry to Solana's vast ecosystem.",
  },
  'NEAR/USD': {
    id: 'NEAR/USD',
    uiName: 'NEAR/USD',
    prodReady: true,
    hideInUi: false,
    hasTime: false,
    sqlDate: '1/31/2024',
    coinSymbol: 'NEAR',
    fiatDecimals: 5,
    type: ASSETS_TYPES.CRYPTO,
    icon: assets.near_icon,
    iconPng: assets.near_icon_png,
    icon2: '',
    icon2Png: '',
    color: '#06EC97',
    games: ['lvg-crypto', 'axe-cap'],
    name: 'NEAR Protocol',
    description:
      'NEAR is the native token of the NEAR Protocol, a highly scalable blockchain network that provides a developer-friendly, decentralized application platform. NEAR tokens are used to pay network fees and can be staked to enhance network security.',
  },
  'TAO/USD': {
    id: 'TAO/USD',
    uiName: 'TAO/USD',
    prodReady: true,
    hideInUi: false,
    hasTime: false,
    sqlDate: '1/31/2024',
    coinSymbol: 'TAO',
    fiatDecimals: 3,
    type: ASSETS_TYPES.CRYPTO,
    icon: assets.tao_icon,
    iconPng: assets.tao_icon_png,
    icon2: '',
    icon2Png: '',
    color: '#000000',
    games: ['lvg-crypto', 'axe-cap'],
    name: 'Bittensor USD',
    description:
      'Bittensor (TAO) is an open-source protocol that powers a decentralized, blockchain-based machine-learning network. TAO is the native cryptocurrency for Bittensor and it is rewarded to machine learning models that train collaboratively and according to the informational value they offer the collective.',
  },
  'MANTA/USD': {
    id: 'MANTA/USD',
    uiName: 'MANTA/USD',
    prodReady: true,
    hideInUi: false,
    hasTime: false,
    sqlDate: '2024-01-25',
    coinSymbol: 'MANTA',
    fiatDecimals: 5,
    type: ASSETS_TYPES.CRYPTO,
    icon: assets.manta_icon,
    iconPng: assets.manta_icon_png,
    icon2: '',
    icon2Png: '',
    color: '#1F6EF8',
    games: ['lvg-crypto', 'axe-cap'],
    name: 'Manta Network (MANTA)',
    description:
      'Manta Pacific is an EVM-compatible network that offers support for decentralized applications and uses Celestia for data availability (technically making it a validium). Built using the OP Stack, Manta Pacific currently has $1.7 billion of value in its smart contracts, falling behind Arbitrum and Optimism.',
  },
  'CFX/USD': {
    id: 'CFX/USD',
    uiName: 'CFX/USD',
    prodReady: true,
    hideInUi: false,
    hasTime: false,
    sqlDate: '2024-01-25',
    coinSymbol: 'CFX',
    fiatDecimals: 5,
    type: ASSETS_TYPES.CRYPTO,
    icon: assets.cfx_icon,
    iconPng: assets.cfx_icon_png,
    icon2: '',
    icon2Png: '',
    color: '#1E1E2C',
    games: ['lvg-crypto', 'axe-cap'],
    name: 'Conflux Network (CFX)',
    description:
      "Conflux Network (CFX) is a high-performance layer 1 blockchain that uses the proof-of-work consensus with proof-of-stake finality. It's built out of China and it's a regulatory-compliant blockchain in the country, which is why Conflux Network is called the “Chinese Ethereum”.",
  },

  'ONDO/USD': {
    id: 'ONDO/USD',
    uiName: 'ONDO/USD',
    prodReady: true,
    hideInUi: false,
    hasTime: false,
    sqlDate: '2024-01-25',
    coinSymbol: 'ONDO',
    fiatDecimals: 5,
    type: ASSETS_TYPES.CRYPTO,
    icon: assets.ondo_icon,
    iconPng: assets.ondo_icon_png,
    icon2: '',
    icon2Png: '',
    color: '#000000',
    games: ['lvg-crypto'],
    name: 'ONDO (ONDO)',
    description:
      'Ondo Finance is a decentralized finance (DeFi) protocol that aims to provide institutional-grade liquidity solutions for tokenized real-world assets. It launched its coin ONDO on January 18, 2024. It debuted with a value of $0.10, skyrocketing in a few days but pulling back a bit after that.',
  },
  'PENDLE/USD': {
    id: 'PENDLE/USD',
    uiName: 'PENDLE/USD',
    prodReady: true,
    hideInUi: false,
    hasTime: false,
    sqlDate: '2024-01-25',
    coinSymbol: 'PENDLE',
    fiatDecimals: 5,
    type: ASSETS_TYPES.CRYPTO,
    icon: assets.pendle_icon,
    iconPng: assets.pendle_icon_png,
    icon2: '',
    icon2Png: '',
    color: '#1F4480',
    games: ['lvg-crypto'],
    name: 'PENDLE (PENDLE)',
    description:
      'Pendle is a protocol that enables the tokenization and trading of future yield. With the creation of a novel AMM that supports assets with time decay, Pendle gives users more control over future yield by providing optionality and opportunities for its utilization.',
  },

  //--------------------------

  'WIF/USD': {
    id: 'WIF/USD',
    uiName: 'WIF/USD',
    prodReady: true,
    hideInUi: false,
    hasTime: false,
    sqlDate: '2024-01-15',
    coinSymbol: 'WIF',
    fiatDecimals: 5,
    type: ASSETS_TYPES.CRYPTO,
    icon: assets.wif_icon,
    iconPng: assets.wif_icon_png,
    icon2: '',
    icon2Png: '',
    color: '#F2B191',
    games: ['lvg-crypto'],
    name: 'Dogwifhat (WIF)',
    description:
      'Dogwifhat (WIF) is a cryptocurrency that operates on the Solana blockchain. It draws inspiration from the Dogwifhat meme and is categorized alongside other dog-themed tokens like BONK, all of which have gained popularity in the community recently.',
  },
  'IMX/USD': {
    id: 'IMX/USD',
    uiName: 'IMX/USD',
    prodReady: true,
    hideInUi: false,
    hasTime: false,
    sqlDate: '2023-11-30',
    coinSymbol: 'IMX',
    fiatDecimals: 5,
    type: ASSETS_TYPES.CRYPTO,
    icon: assets.imx_icon,
    iconPng: assets.imx_icon_png,
    icon2: '',
    icon2Png: '',
    color: '#1AA29B',
    games: ['lvg-crypto'],
    name: 'Impermax',
    description:
      'Impermax is an automated crypto lending platform that allows users to use their liquidity provider tokens as collateral for permissionless loans. LP tokens are the coins allocated to liquidity providers on a (DEX) decentralized exchange.',
  },
  'SUI/USD': {
    id: 'SUI/USD',
    uiName: 'SUI/USD',
    prodReady: true,
    hideInUi: false,
    hasTime: false,
    sqlDate: '2023-11-30',
    coinSymbol: 'SUI',
    fiatDecimals: 5,
    type: ASSETS_TYPES.CRYPTO,
    icon: assets.sui_icon,
    iconPng: assets.sui_icon_png,
    icon2: '',
    icon2Png: '',
    color: '#6DA5D9',
    games: ['lvg-crypto'],
    name: 'Sui',
    description:
      'SUI Blockchain is a decentralized digital ledger that revolutionizes data storage with object-centric design, enabling gasless transactions and unparalleled composability. It redefines how we interact with Web3 technology.',
  },
  'CYBER/USD': {
    id: 'CYBER/USD',
    uiName: 'CYBER/USD',
    prodReady: true,
    hideInUi: false,
    hasTime: false,
    sqlDate: '2023-11-30',
    coinSymbol: 'CYBER',
    fiatDecimals: 5,
    type: ASSETS_TYPES.CRYPTO,
    icon: assets.cyber_icon,
    iconPng: assets.cyber_icon_png,
    icon2: '',
    icon2Png: '',
    color: '#000000',
    games: ['lvg-crypto'],
    name: 'Cyberpunk City',
    description:
      'Cyberpunk City is a play-to-earn blockchain massively multiplayer online role-playing game metaverse where players can own NFT characters and earn CYBER tokens on the Elrond network.',
  },
  'SEI/USD': {
    id: 'SEI/USD',
    uiName: 'SEI/USD',
    prodReady: true,
    hideInUi: false,
    hasTime: false,
    sqlDate: '2023-11-30',
    coinSymbol: 'SEI',
    fiatDecimals: 5,
    type: ASSETS_TYPES.CRYPTO,
    icon: assets.sei_icon,
    iconPng: assets.sei_icon_png,
    icon2: '',
    icon2Png: '',
    color: '#110D22',
    games: ['lvg-crypto'],
    name: 'Sei',
    description:
      'Sei is a general purpose, open-source Layer 1 blockchain specialized for the exchange of digital assets. Leveraging a novel consensus and technical breakthroughs, Sei is the fastest blockchain in the industry. A common misconception is that Sei is a DeFi chain.',
  },
  'PYTH/USD': {
    id: 'PYTH/USD',
    uiName: 'PYTH/USD',
    prodReady: true,
    hideInUi: false,
    hasTime: false,
    sqlDate: '2023-11-28',
    coinSymbol: 'PYTH/USD',
    fiatDecimals: 5,
    type: ASSETS_TYPES.CRYPTO,
    icon: assets.pyth_icon,
    iconPng: assets.pyth_icon_png,
    icon2: '',
    icon2Png: '',
    color: '#110D22',
    games: ['lvg-crypto'],
    name: 'Pyth Network (PYTH)',
    description:
      'Pyth Network is a blockchain-based platform that provides high-quality financial market data, primarily for decentralized finance (DeFi). It aggregates real-time, accurate price feeds for various assets, including cryptocurrencies, equities, and commodities.',
  },
  '1000BONK/USD': {
    id: '1000BONK/USD',
    uiName: '1000BONK/USD',
    prodReady: true,
    hideInUi: false,
    hasTime: false,
    sqlDate: '2023-11-21',
    coinSymbol: '1000BONK/USD',
    fiatDecimals: 7,
    type: ASSETS_TYPES.CRYPTO,
    icon: assets.bonk_icon,
    iconPng: assets.bonk_icon_png,
    icon2: '',
    icon2Png: '',
    color: '#F38D00',
    games: ['lvg-crypto'],
    name: 'Bonk (BONK)',
    description:
      "BONK is the very first Dog-themed memecoin on Solana that's “for the people, by the people.” The document states: The BONK contributors were tired of toxic “Alameda” tokenomics and wanted to make a fun memecoin where everyone gets a fair shot.",
  },
  'MEME/USD': {
    id: 'MEME/USD',
    uiName: 'MEME/USD',
    prodReady: true,
    hideInUi: false,
    hasTime: false,
    sqlDate: '2023-11-13',
    coinSymbol: 'MEME/USD',
    fiatDecimals: 3,
    type: ASSETS_TYPES.CRYPTO,
    icon: assets.meme_icon,
    iconPng: assets.meme_icon_png,
    icon2: '',
    icon2Png: '',
    color: '#4B7B4D',
    games: ['lvg-crypto'],
    name: 'Memetic / PepeCoin (MEME)',
    description:
      'Memetic / PepeCoin is an open-source peer-to-peer cryptocurrency, usually shortened as its ticker name MEME. It belongs to the subdivision of memecoins, which are based on funny viral images on the Internet. Some notorious examples of such coins include Dogecoin.',
  },
  'TIA/USD': {
    id: 'TIA/USD',
    uiName: 'TIA/USD',
    prodReady: true,
    hideInUi: false,
    hasTime: false,
    sqlDate: '2023-11-13',
    coinSymbol: 'TIA/USD',
    fiatDecimals: 3,
    type: ASSETS_TYPES.CRYPTO,
    icon: assets.tia_icon,
    iconPng: assets.tia_icon_png,
    icon2: '',
    icon2Png: '',
    color: '#610AD8',
    games: ['lvg-crypto'],
    name: 'Celestia (TIA)',
    description: 'The first modular blockchain network that securely scales with the number of users.',
  },
  'GAS/USD': {
    id: 'GAS/USD',
    uiName: 'GAS/USD',
    prodReady: true,
    hideInUi: false,
    hasTime: false,
    sqlDate: '2023-11-13',
    coinSymbol: 'GAS/USD',
    fiatDecimals: 3,
    type: ASSETS_TYPES.CRYPTO,
    icon: assets.gas_icon,
    iconPng: assets.gas_icon_png,
    icon2: '',
    icon2Png: '',
    color: '#77ECB6',
    games: ['lvg-crypto'],
    name: 'Gas (GAS)',
    description:
      ' The gas acts as a token specially created for the NEO blockchain to pay fees for carrying transactions on NEO networks. In other words, it is a cryptocurrency used to fulfill a transaction on the NEO blockchain.',
  },
  FRIEND: {
    id: 'FRIEND',
    uiName: 'FRIEND',
    prodReady: true,
    hideInUi: true,
    hasTime: false,
    sqlDate: '2023-09-15',
    coinSymbol: 'FRIEND',
    fiatDecimals: 5,
    type: ASSETS_TYPES.CRYPTO,
    icon: assets.friend_tech_icon,
    iconPng: assets.friend_tech_icon_png,
    icon2: '',
    icon2Png: '',
    color: '#00BBFC',
    games: ['lvg-crypto'],
    name: 'yoloETF FRIEND',
    description:
      "yoloETF's Friend Tech Key Price Index (FRND/USD) is an experimental ETF tracking the key price of top accounts on frend.tech, including influencers such as 0xRacerAlt, 0xCaptainLevi, HsakaTrades, Vombatus_eth, HerroCrypto, and more. Curated by YOLOREKT, this index offers a unique perspective on the market dynamics shaped by these influential figures.",
  },
  'UNIBOT/USD': {
    id: 'UNIBOT/USD',
    uiName: 'UNIBOT/USD',
    prodReady: true,
    hideInUi: false,
    hasTime: false,
    sqlDate: '2023-08-29',
    coinSymbol: 'UNIBOT',
    fiatDecimals: 5,
    type: ASSETS_TYPES.CRYPTO,
    icon: assets.unibot_icon,
    iconPng: assets.unibot_icon_png,
    icon2: '',
    icon2Png: '',
    color: '#7B2C80',
    games: ['lvg-crypto'],
    name: 'UniBot (UNIBOT)',
    description:
      'Unibot (UNIBOT) is a Telegram bot that enables you to trade crypto tokens on Uniswap v3 directly from the Telegram messaging app. It is a Leveraged Liquidity Provision (LLP) platform developed for Uniswap v3 by Diamond Protocol, a DeFi protocol focused on modeling on-chain structured products.',
  },
  XOM: {
    id: 'XOM',
    uiName: 'yXOM',
    prodReady: true,
    hideInUi: false,
    hasTime: true,
    sqlDate: '2023-07-28',
    coinSymbol: 'yXOM',
    fiatDecimals: 2,
    type: ASSETS_TYPES.STOCKS,
    icon: assets.xom_icon,
    iconPng: assets.xom_icon_png,
    icon2: '',
    icon2Png: '',
    color: '#FE0300',
    games: ['lvg-stocks'],
    name: 'Exxon Mobil Corporation YOLOREKT Synthetic Stock',
    description:
      'Exxon Mobil Corporation engages in the exploration and production of crude oil and natural gas in the United States and internationally. It operates through Upstream, Energy Products, Chemical Products, and Specialty Products segments.',
  },
  PG: {
    id: 'PG',
    uiName: 'yPG',
    prodReady: true,
    hideInUi: false,
    hasTime: true,
    sqlDate: '2023-07-28',
    coinSymbol: 'yPG',
    fiatDecimals: 2,
    type: ASSETS_TYPES.STOCKS,
    icon: assets.pg_icon,
    iconPng: assets.pg_icon_png,
    icon2: '',
    icon2Png: '',
    color: '#003EA6',
    games: ['lvg-stocks'],
    name: 'The Procter & Gamble Company YOLOREKT Synthetic Stock',
    description:
      'The Procter & Gamble Company provides branded consumer packaged goods worldwide. It operates through five segments: Beauty; Grooming; Health Care; Fabric & Home Care; and Baby, Feminine & Family Care.',
  },
  'WLD/USD': {
    id: 'WLD/USD',
    uiName: 'WLD/USD',
    prodReady: true,
    hideInUi: false,
    hasTime: false,
    sqlDate: '2023-07-24',
    coinSymbol: 'WLD',
    fiatDecimals: 5,
    type: ASSETS_TYPES.CRYPTO,
    icon: assets.wld_icon,
    iconPng: assets.wld_icon_png,
    icon2: '',
    icon2Png: '',
    color: '#000000',
    games: ['lvg-crypto'],
    name: 'Worldcoin (WLD)',
    description:
      "Worldcoin, the ambitious cryptocurrency and digital ID project spearheaded by OpenAI chief Sam Altman, launched on Monday after years in development, promising to verify users' identity by scanning their eyes and potentially solving one of the more pressing problems posed by recent advances in artificial intelligence.",
  },
  'BCH/USD': {
    id: 'BCH/USD',
    uiName: 'BCH/USD',
    prodReady: true,
    hideInUi: false,
    hasTime: false,
    sqlDate: '2023-07-03',
    coinSymbol: 'BCH',
    fiatDecimals: 5,
    type: ASSETS_TYPES.CRYPTO,
    icon: assets.bch_icon,
    iconPng: assets.bch_icon_png,
    icon2: '',
    icon2Png: '',
    color: '#0CC18D',
    games: ['lvg-crypto'],
    name: 'Bitcoin Cash (BCH)',
    description:
      'Bitcoin Cash (BCH) is an altcoin version of the popular Bitcoin cryptocurrency. Bitcoin Cash is the result of a hard fork in blockchain technology. One of the most significant changes from Bitcoin to Bitcoin Cash is the size of the coin.',
  },
  AutoGPT: {
    id: 'AutoGPT',
    uiName: 'AutoGPT',
    prodReady: true,
    hideInUi: false,
    hasTime: true,
    sqlDate: '2023-06-30',
    coinSymbol: 'AutoGPT',
    fiatDecimals: 3,
    type: ASSETS_TYPES.YOLO_ETF,
    icon: assets.autogpt_icon,
    iconPng: assets.autogpt_icon_png,
    icon2: '',
    icon2Png: '',
    color: '#000000',
    games: ['lvg-ai_indexes'],
    name: 'yoloETF AutoGPT',
    description:
      'Auto-GPT is an experimental, open source autonomous AI agent based on the GPT-4 language model. Auto-GPT autonomously chains together tasks to achieve a big-picture goal set by the user. It automates the multi-step prompting process typically required to operate a chatbot such as ChatGPT.',
  },
  PLD: {
    id: 'PLD',
    uiName: 'yPLD',
    prodReady: true,
    hideInUi: false,
    hasTime: true,
    sqlDate: '2023-06-20',
    coinSymbol: 'yPLD',
    fiatDecimals: 2,
    type: ASSETS_TYPES.STOCKS,
    icon: assets.pld_icon,
    iconPng: assets.pld_icon_png,
    icon2: '',
    icon2Png: '',
    color: '#2C728A',
    games: ['lvg-stocks'],
    name: 'Prologis Inc. YOLOREKT Synthetic Stock',
    description:
      'Prologis, Inc. is the global leader in logistics real estate with a focus on high-barrier, high-growth markets.',
  },
  AMT: {
    id: 'AMT',
    uiName: 'yAMT',
    prodReady: true,
    hideInUi: false,
    hasTime: true,
    sqlDate: '2023-06-20',
    coinSymbol: 'yAMT',
    fiatDecimals: 2,
    type: ASSETS_TYPES.STOCKS,
    icon: assets.amt_icon,
    iconPng: assets.amt_icon_png,
    icon2: '',
    icon2Png: '',
    color: '#DA0D46',
    games: ['lvg-stocks'],
    name: 'American Tower YOLOREKT Synthetic Stock',
    description:
      'American Tower, one of the largest global REITs, is a leading independent owner, operator and developer of multitenant communications real estate with a portfolio of nearly 226,000 communications sites and a highly interconnected footprint of U.S. data center facilities.',
  },
  EQIX: {
    id: 'EQIX',
    uiName: 'yEQIX',
    prodReady: true,
    hideInUi: false,
    hasTime: true,
    sqlDate: '2023-06-20',
    coinSymbol: 'yEQIX',
    fiatDecimals: 2,
    type: ASSETS_TYPES.STOCKS,
    icon: assets.eqix_icon,
    iconPng: assets.eqix_icon_png,
    icon2: '',
    icon2Png: '',
    color: '#EF2E31',
    games: ['lvg-stocks'],
    name: 'Equinix YOLOREKT Synthetic Stock',
    description:
      "Equinix (Nasdaq: EQIX) is the world's digital infrastructure company, enabling digital leaders to harness a trusted platform to bring together and interconnect the foundational infrastructure that powers their success. Equinix enables today's businesses to access all the right places, partners and possibilities they need to accelerate advantage. With Equinix, they can scale with agility, speed the launch of digital services, deliver world-class experiences and multiply their value.",
  },
  'USDC/USDT': {
    id: 'USDC/USDT',
    uiName: 'USDC/USDT',
    prodReady: true,
    hideInUi: true,
    hasTime: false,
    sqlDate: '2023-06-15',
    coinSymbol: 'USDC',
    fiatDecimals: 4,
    type: ASSETS_TYPES.CRYPTO,
    icon: assets.usdc_icon,
    iconPng: assets.usdc_icon_png,
    icon2: assets.usdt_icon,
    icon2Png: assets.usdt_icon_png,
    color: '#54AE94',
    games: ['lvg-crypto'],
    name: 'USD Coin (USDC) / Tether (USDT)',
    description:
      "Tether (USDT) is what's known as a “Stablecoin” – a cryptocurrency designed to provide a stable price point at all times. The USDT cryptocurrency was created by Tether Limited to function as the internet's Digital Dollar, with each token worth $1.00 USD and backed by $1.00 USD in physical reserves.",
  },
  NIO: {
    id: 'NIO',
    uiName: 'yNIO',
    prodReady: true,
    hideInUi: false,
    hasTime: true,
    sqlDate: '2023-06-14',
    coinSymbol: 'yNIO',
    fiatDecimals: 2,
    type: ASSETS_TYPES.STOCKS,
    icon: assets.nio_icon,
    iconPng: assets.nio_icon_png,
    icon2: '',
    icon2Png: '',
    color: '#1EA7A8',
    games: ['lvg-stocks'],
    name: 'NIO, Inc. YOLOREKT Synthetic Stock',
    description:
      'NIO Inc. designs, develops, manufactures, and sells smart electric vehicles in China. It offers five and six-seater electric SUVs, as well as smart electric sedans. The company also offers power solutions, including Power Home, a home charging solution; Power Swap, a battery swapping service; Power Charger and Destination Charger; Power Mobile, a mobile charging service through charging vans; Power Map, an application that provides access to a network of public chargers and their real-time information; and One Click for Power valet service.',
  },
  CVNA: {
    id: 'CVNA',
    uiName: 'yCVNA',
    prodReady: true,
    hideInUi: false,
    hasTime: true,
    sqlDate: '2023-06-14',
    coinSymbol: 'yCVNA',
    fiatDecimals: 2,
    type: ASSETS_TYPES.STOCKS,
    icon: assets.cvna_icon,
    iconPng: assets.cvna_icon_png,
    icon2: '',
    icon2Png: '',
    color: '#01ACD8',
    games: ['lvg-stocks'],
    name: 'Carvana Co. YOLOREKT Synthetic Stock',
    description:
      "Carvana Co., together with its subsidiaries, operates an e-commerce platform for buying and selling used cars in the United States. Its platform allows customers to research and identify a vehicle; inspect it using company's 360-degree vehicle imaging technology; obtain financing and warranty coverage; purchase the vehicle; and schedule delivery or pick-up from their desktop or mobile devices.",
  },
  SOFI: {
    id: 'SOFI',
    uiName: 'ySOFI',
    prodReady: true,
    hideInUi: false,
    hasTime: true,
    sqlDate: '2023-06-14',
    coinSymbol: 'ySOFI',
    fiatDecimals: 2,
    type: ASSETS_TYPES.STOCKS,
    icon: assets.sofi_icon,
    iconPng: assets.sofi_icon_png,
    icon2: '',
    icon2Png: '',
    color: '#00A2C7',
    games: ['lvg-stocks'],
    name: 'SoFi Technologies, Inc. YOLOREKT Synthetic Stock',
    description:
      'SoFi Technologies, Inc. provides various financial services. It operates through three segments: Lending, Technology Platform, and Financial Services. The company offers lending and financial services and products that allows its members to borrow, save, spend, invest, and protect money. It also offers personal loans, student loans, home loans, and related services.',
  },
  AMD: {
    id: 'AMD',
    uiName: 'yAMD',
    prodReady: true,
    hideInUi: false,
    hasTime: true,
    sqlDate: '2023-06-14',
    coinSymbol: 'yAMD',
    fiatDecimals: 2,
    type: ASSETS_TYPES.STOCKS,
    icon: assets.amd_icon,
    iconPng: assets.amd_icon_png,
    icon2: '',
    icon2Png: '',
    color: '#000000',
    games: ['lvg-stocks'],
    name: 'Advanced Micro Devices, Inc. YOLOREKT Synthetic Stock',
    description:
      'Advanced Micro Devices, Inc. operates as a semiconductor company worldwide. It operates in four segments: Data Center, Client, Gaming, and Embedded segments.',
  },
  KMX: {
    id: 'KMX',
    uiName: 'yKMX',
    prodReady: true,
    hideInUi: false,
    hasTime: true,
    sqlDate: '2023-06-08',
    coinSymbol: 'yKMX',
    fiatDecimals: 2,
    type: ASSETS_TYPES.STOCKS,
    icon: assets.kmx_icon,
    iconPng: assets.kmx_icon_png,
    icon2: '',
    icon2Png: '',
    color: '#053361',
    games: ['lvg-stocks'],
    name: 'CarMax, Inc. YOLOREKT Synthetic Stock',
    description:
      'CarMax, Inc., together with its subsidiaries, operates as a retailer of used vehicles in the United States. It operates in two segments, CarMax Sales Operations and CarMax Auto Finance.',
  },
  DOCU: {
    id: 'DOCU',
    uiName: 'yDOCU',
    prodReady: true,
    hideInUi: false,
    hasTime: true,
    sqlDate: '2023-06-08',
    coinSymbol: 'yDOCU',
    fiatDecimals: 2,
    type: ASSETS_TYPES.STOCKS,
    icon: assets.docu_icon,
    iconPng: assets.docu_icon_png,
    icon2: '',
    icon2Png: '',
    color: '#191823',
    games: ['lvg-stocks'],
    name: 'DocuSign, Inc. YOLOREKT Synthetic Stock',
    description:
      'DocuSign, Inc. provides electronic signature solution in the United States and internationally. The company provides DocuSign e-signature solution that enables sending and signing of agreements on various devices; Contract Lifecycle Management (CLM), which automates workflows across the entire agreement process; and Gen for Salesforce, which allows sales representatives to automatically generate agreements with a few clicks from within Salesforce.',
  },
  MANU: {
    id: 'MANU',
    uiName: 'yMANU',
    prodReady: true,
    hideInUi: false,
    hasTime: true,
    sqlDate: '2023-06-08',
    coinSymbol: 'yMANU',
    fiatDecimals: 2,
    type: ASSETS_TYPES.STOCKS,
    icon: assets.manu_icon,
    iconPng: assets.manu_icon_png,
    icon2: '',
    icon2Png: '',
    color: '#C70300',
    games: ['lvg-stocks'],
    name: 'Manchester United PLC YOLOREKT Synthetic Stock',
    description:
      'Manchester United plc, together with its subsidiaries, owns and operates a professional sports team in the United Kingdom. It operates Manchester United Football Club, a professional football club.',
  },
  AI: {
    id: 'AI',
    uiName: 'yAI',
    prodReady: true,
    hideInUi: false,
    hasTime: true,
    sqlDate: '2023-06-08',
    coinSymbol: 'yAI',
    fiatDecimals: 2,
    type: ASSETS_TYPES.STOCKS,
    icon: assets.ai_icon,
    iconPng: assets.ai_icon_png,
    icon2: '',
    icon2Png: '',
    color: '#1A1A1A',
    games: ['lvg-stocks'],
    name: 'C3.ai, Inc. YOLOREKT Synthetic Stock',
    description:
      'C3.ai, Inc. operates as an enterprise artificial intelligence (AI) software company in North America, Europe, the Middle East, Africa, the Asia Pacific, and internationally. It provides C3 AI application platform, an application development and runtime environment that enables customers to design, develop, and deploy enterprise AI applications; C3 AI Ex Machina to for analysis-ready data; C3 AI CRM, an industry specific customer relationship management solution; and C3 AI Data Vision that visualizes, understands, and leverages the relationships between data entities.',
  },
  'AXS/USD': {
    id: 'AXS/USD',
    uiName: 'AXS/USD',
    prodReady: true,
    hideInUi: false,
    hasTime: false,
    sqlDate: '2023-06-05',
    coinSymbol: 'AXS',
    fiatDecimals: 3,
    type: ASSETS_TYPES.CRYPTO,
    icon: assets.axs_icon,
    iconPng: assets.axs_icon_png,
    icon2: '',
    icon2Png: '',
    color: '#0056D5',
    games: ['lvg-crypto'],
    name: 'Axie Infinity (AXS)',
    description:
      'Axie Infinity (AXS) is an Ethereum token that powers Axie Infinity, a blockchain-based game where players can battle, collect, and build a digital kingdom for their pets. AXS holders can claim rewards for staking their tokens, playing the game, and participating in key governance votes.',
  },
  'MANA/USD': {
    id: 'MANA/USD',
    uiName: 'MANA/USD',
    prodReady: true,
    hideInUi: false,
    hasTime: false,
    sqlDate: '2023-06-05',
    coinSymbol: 'MANA',
    fiatDecimals: 4,
    type: ASSETS_TYPES.CRYPTO,
    icon: assets.mana_icon,
    iconPng: assets.mana_icon_png,
    icon2: '',
    icon2Png: '',
    color: '#FE3D56',
    games: ['lvg-crypto'],
    name: 'Decentraland (MANA)',
    description:
      'Decentraland (MANA) is the digital asset token used to pay for goods and services in Decentraland. It is built on Ethereum in accordance with the ERC20 standard for tokens. MANA can be bought and sold for fiat currency or other digital currencies. MANA can be stored in a crypto wallet and custodian like Gemini.',
  },
  'SAND/USD': {
    id: 'SAND/USD',
    uiName: 'SAND/USD',
    prodReady: true,
    hideInUi: true,
    hasTime: false,
    sqlDate: '2023-06-05',
    coinSymbol: 'SAND',
    fiatDecimals: 4,
    type: ASSETS_TYPES.CRYPTO,
    icon: assets.sand_icon,
    iconPng: assets.sand_icon_png,
    icon2: '',
    icon2Png: '',
    color: '#0095F9',
    games: ['lvg-crypto'],
    name: 'Sandbox (SAND)',
    description:
      'Sandbox (SAND) is the utility token used throughout The Sandbox ecosystem as the basis for transactions and interactions. It is an ERC-20 utility token built on the Ethereum blockchain. There is a finite supply of 3,000,000,000 SAND.',
  },
  'LINA/USD': {
    id: 'LINA/USD',
    uiName: 'LINA/USD',
    prodReady: true,
    hideInUi: false,
    hasTime: false,
    sqlDate: '2023-06-02',
    coinSymbol: 'LINA',
    fiatDecimals: 5,
    type: ASSETS_TYPES.CRYPTO,
    icon: assets.lina_icon,
    iconPng: assets.lina_icon_png,
    icon2: '',
    icon2Png: '',
    color: '#2949F9',
    games: ['lvg-crypto'],
    name: 'Linear Finance (LINA)',
    description:
      'Linear Finance (LINA) is a governance token and holders can decide on important issues that affect the protocol. The token is also required as base collateral for creating Liquids. Using LINA to create lUSD entitles users to staking rewards and a share of the trading fees from Linear Exchange.',
  },
  SNAP: {
    id: 'SNAP',
    uiName: 'ySNAP',
    prodReady: true,
    hideInUi: false,
    hasTime: true,
    sqlDate: '2023-05-25',
    coinSymbol: 'ySNAP',
    fiatDecimals: 2,
    type: ASSETS_TYPES.STOCKS,
    icon: assets.snap_icon,
    iconPng: assets.snap_icon_png,
    icon2: '',
    icon2Png: '',
    color: '#FEFC00',
    games: ['lvg-stocks'],
    name: 'Snap Inc. YOLOREKT Synthetic Stock',
    description:
      'Snap Inc. operates as a technology company in North America, Europe, and internationally. The company offers Snapchat, a visual messaging application with various tabs, such as camera, visual messaging, snap map, stories, and spotlight that enable people to communicate visually through short videos and images.',
  },
  MSFT: {
    id: 'MSFT',
    uiName: 'yMSFT',
    prodReady: true,
    hideInUi: false,
    hasTime: true,
    sqlDate: '2023-05-25',
    coinSymbol: 'yMSFT',
    fiatDecimals: 2,
    type: ASSETS_TYPES.STOCKS,
    icon: assets.msft_icon,
    iconPng: assets.msft_icon_png,
    icon2: '',
    icon2Png: '',
    color: '#03A4F0',
    games: ['lvg-stocks'],
    name: 'Microsoft Corporation YOLOREKT Synthetic Stock',
    description:
      'Microsoft Corp. engages in the development and support of software, services, devices, and solutions. It operates through the following business segments: Productivity and Business Processes, Intelligent Cloud, and More Personal Computing.',
  },
  META: {
    id: 'META',
    uiName: 'yMETA',
    prodReady: true,
    hideInUi: false,
    hasTime: true,
    sqlDate: '2023-05-25',
    coinSymbol: 'yMETA',
    fiatDecimals: 2,
    type: ASSETS_TYPES.STOCKS,
    icon: assets.meta_icon,
    iconPng: assets.meta_icon_png,
    icon2: '',
    icon2Png: '',
    color: '#4867AA',
    games: ['lvg-stocks'],
    name: 'Meta Platforms Inc. YOLOREKT Synthetic Stock',
    description:
      'Meta Platforms Inc (Meta), formerly Facebook Inc, is a provider of social networking, advertising, and business insight solutions. The company, through its virtual-reality vision, the metaverse, focuses on developing virtual environment that allows people to interact and connect with technology.',
  },
  COIN: {
    id: 'COIN',
    uiName: 'yCOIN',
    prodReady: true,
    hideInUi: false,
    hasTime: true,
    sqlDate: '2023-05-25',
    coinSymbol: 'yCOIN',
    fiatDecimals: 2,
    type: ASSETS_TYPES.STOCKS,
    icon: assets.coin_icon,
    iconPng: assets.coin_icon_png,
    icon2: '',
    icon2Png: '',
    color: '#0052FF',
    games: ['lvg-stocks'],
    name: 'Coinbase Global Inc. YOLOREKT Synthetic Stock',
    description:
      'Coinbase Global, Inc. provides financial infrastructure and technology for the cryptoeconomy in the United States and internationally. It offers the primary financial account in the cryptoeconomy for consumers; and a marketplace with a pool of liquidity for transacting in crypto assets for institutions.',
  },
  SQQQ: {
    id: 'SQQQ',
    uiName: 'ySQQQ',
    prodReady: true,
    hideInUi: false,
    hasTime: true,
    sqlDate: '2023-05-25',
    coinSymbol: 'ySQQQ',
    fiatDecimals: 2,
    type: ASSETS_TYPES.STOCKS,
    icon: assets.sqqq_icon,
    iconPng: assets.sqqq_icon_png,
    icon2: '',
    icon2Png: '',
    color: '#91CC67',
    games: ['lvg-stocks'],
    name: 'ProShares UltraPro Short QQQ YOLOREKT Synthetic Stock',
    description:
      'ProShares UltraPro Short QQQ seeks a return that is -3x the return of its index (target) for a single day, as measured from one NAV calculation to the next.',
  },
  TQQQ: {
    id: 'TQQQ',
    uiName: 'yTQQQ',
    prodReady: true,
    hideInUi: false,
    hasTime: true,
    sqlDate: '2023-05-25',
    coinSymbol: 'yTQQQ',
    fiatDecimals: 2,
    type: ASSETS_TYPES.STOCKS,
    icon: assets.tqqq_icon,
    iconPng: assets.tqqq_icon_png,
    icon2: '',
    icon2Png: '',
    color: '#00A7CD',
    games: ['lvg-stocks'],
    name: 'ProShares UltraPro QQQ YOLOREKT Synthetic Stock',
    description:
      'ProShares UltraPro QQQ seeks a return that is 3x the return of its index (target) for a single day, as measured from one NAV calculation to the next.',
  },
  SOXL: {
    id: 'SOXL',
    uiName: 'ySOXL',
    prodReady: true,
    hideInUi: false,
    hasTime: true,
    sqlDate: '2023-05-25',
    coinSymbol: 'ySOXL',
    fiatDecimals: 2,
    type: ASSETS_TYPES.STOCKS,
    icon: assets.soxl_icon,
    iconPng: assets.soxl_icon_png,
    icon2: '',
    icon2Png: '',
    color: '#0064A7',
    games: ['lvg-stocks'],
    name: 'Direxion Daily Semiconductor Bull 3X Shares YOLOREKT Synthetic Stock',
    description:
      'SOXL is an aggressive and bullish 1-day bet on a concentrated portfolio of the 30 largest US-listed semiconductor companies, including manufacturers and providers of services or equipment associated with semiconductors.',
  },
  LABU: {
    id: 'LABU',
    uiName: 'yLABU',
    prodReady: true,
    hideInUi: false,
    hasTime: true,
    sqlDate: '2023-05-25',
    coinSymbol: 'yLABU',
    fiatDecimals: 2,
    type: ASSETS_TYPES.STOCKS,
    icon: assets.labu_icon,
    iconPng: assets.labu_icon_png,
    icon2: '',
    icon2Png: '',
    color: '#781B85',
    games: ['lvg-stocks'],
    name: 'Direxion Daily S&P Biotech Bull 3X Shares YOLOREKT Synthetic Stock',
    description:
      'The Direxion Daily S&P Biotech Bull 3X Fund (LABU) is an ETF that seeks to replicate 300% of the daily performance of its benchmark, the S&P Biotechnology Select Industry Index. The fund invests primarily in swap agreements and futures contracts that provide daily leveraged exposure to the benchmark index.',
  },
  SH: {
    id: 'SH',
    uiName: 'ySH',
    prodReady: true,
    hideInUi: false,
    hasTime: true,
    sqlDate: '2023-05-25',
    coinSymbol: 'ySH',
    fiatDecimals: 2,
    type: ASSETS_TYPES.STOCKS,
    icon: assets.sh_icon,
    iconPng: assets.sh_icon_png,
    icon2: '',
    icon2Png: '',
    color: '#56355B',
    games: ['lvg-stocks'],
    name: 'ProShares Short S&P500 YOLOREKT Synthetic Stock',
    description:
      'ProShares Short S&P500 seeks daily investment results, before fees and expenses, that correspond to the inverse (-1x) of the daily performance of the S&P 500®.',
  },
  XLF: {
    id: 'XLF',
    uiName: 'yXLF',
    prodReady: true,
    hideInUi: false,
    hasTime: true,
    sqlDate: '2023-05-25',
    coinSymbol: 'yXLF',
    fiatDecimals: 2,
    type: ASSETS_TYPES.STOCKS,
    icon: assets.xlf_icon,
    iconPng: assets.xlf_icon_png,
    icon2: '',
    icon2Png: '',
    color: '#53655D',
    games: ['lvg-stocks'],
    name: 'Financial Select Sector SPDR Fund YOLOREKT Synthetic Stock',
    description:
      'XLF offers efficient exposure to the heavyweights in the US financials segment. Its cap-weighted, S&P 500-only portfolio means that it’s concentrated in large banks and avoids small-caps. For many investors and traders, XLF has been the go-to ETF for financials exposure, although there are more comprehensive funds out there for long-term exposure',
  },
  EEM: {
    id: 'EEM',
    uiName: 'yEEM',
    prodReady: true,
    hideInUi: false,
    hasTime: true,
    sqlDate: '2023-05-25',
    coinSymbol: 'yEEM',
    fiatDecimals: 2,
    type: ASSETS_TYPES.STOCKS,
    icon: assets.eem_icon,
    iconPng: assets.eem_icon_png,
    icon2: '',
    icon2Png: '',
    color: '#273F33',
    games: ['lvg-stocks'],
    name: 'iShares MSCI Emerging Markets ETF YOLOREKT Synthetic Stock',
    description:
      'EEM one of the early entrants to provide exposure to large- and midcap emerging market equities. The fund matches the market well. In fact, it uses a similar, albeit narrower version of our MSCI benchmark.',
  },
  HYG: {
    id: 'HYG',
    uiName: 'yHYG',
    prodReady: true,
    hideInUi: false,
    hasTime: true,
    sqlDate: '2023-05-25',
    coinSymbol: 'yHYG',
    fiatDecimals: 2,
    type: ASSETS_TYPES.STOCKS,
    icon: assets.hyg_icon,
    iconPng: assets.hyg_icon_png,
    icon2: '',
    icon2Png: '',
    color: '#1181F2',
    games: ['lvg-stocks'],
    name: 'iShares iBoxx $ High Yield Corporate Bond ETF YOLOREKT Synthetic Stock',
    description:
      'HYG was the first mover in the high-yield corporate bond market. For many years it’s been one of the largest and most liquid junk bond ETFs, along with archrival JNK. Its core exposure through the iBoxx index it tracks is solid, covering the most liquid corner of the junk bond market.',
  },
  SPXU: {
    id: 'SPXU',
    uiName: 'ySPXU',
    prodReady: true,
    hideInUi: false,
    hasTime: true,
    sqlDate: '2023-05-25',
    coinSymbol: 'ySPXU',
    fiatDecimals: 2,
    type: ASSETS_TYPES.STOCKS,
    icon: assets.spxu_icon,
    iconPng: assets.spxu_icon_png,
    icon2: '',
    icon2Png: '',
    color: '#3757DF',
    games: ['lvg-stocks'],
    name: 'ProShares UltraPro Short S&P500 YOLOREKT Synthetic Stock',
    description:
      'SPXU seeks to replicate the S&P 500 performance, but in the opposite direction and multiplied by three. SPXU is not suitable for long-term investing and is meant to be held for one day or less. The SPXU is a speculative investment that carries significant risk, and investors can lose all of their investment.',
  },
  FXI: {
    id: 'FXI',
    uiName: 'yFXI',
    prodReady: true,
    hideInUi: false,
    hasTime: true,
    sqlDate: '2023-05-25',
    coinSymbol: 'yFXI',
    fiatDecimals: 2,
    type: ASSETS_TYPES.STOCKS,
    icon: assets.fxi_icon,
    iconPng: assets.fxi_icon_png,
    icon2: '',
    icon2Png: '',
    color: '#C1D83F',
    games: ['lvg-stocks'],
    name: 'iShares China Large-Cap ETF YOLOREKT Synthetic Stock',
    description:
      'FXI, one of the oldest China-focused ETFs on the market, is a concentrated portfolio of 50 large cap H-shares, P-chips and Red Chips listed in Hong Kong.',
  },
  XLE: {
    id: 'XLE',
    uiName: 'yXLE',
    prodReady: true,
    hideInUi: false,
    hasTime: true,
    sqlDate: '2023-05-25',
    coinSymbol: 'yXLE',
    fiatDecimals: 2,
    type: ASSETS_TYPES.STOCKS,
    icon: assets.xle_icon,
    iconPng: assets.xle_icon_png,
    icon2: '',
    icon2Png: '',
    color: '#FFCB08',
    games: ['lvg-stocks'],
    name: 'Energy Select Sector SPDR Fund YOLOREKT Synthetic Stock',
    description: 'XLE tracks a market-cap-weighted index of US energy companies in the S&P 500.',
  },
  IWM: {
    id: 'IWM',
    uiName: 'yIWM',
    prodReady: true,
    hideInUi: false,
    hasTime: true,
    sqlDate: '2023-05-25',
    coinSymbol: 'yIWM',
    fiatDecimals: 2,
    type: ASSETS_TYPES.STOCKS,
    icon: assets.iwm_icon,
    iconPng: assets.iwm_icon_png,
    icon2: '',
    icon2Png: '',
    color: '#0E4A68',
    games: ['lvg-stocks'],
    name: 'iShares Russell 2000 ETF YOLOREKT Synthetic Stock',
    description:
      'IWM tracks a market-cap-weighted index of US small-cap stocks. The index selects stocks ranked 1,001-3,000 by market cap.',
  },
  GDX: {
    id: 'GDX',
    uiName: 'yGDX',
    prodReady: true,
    hideInUi: false,
    hasTime: true,
    sqlDate: '2023-05-25',
    coinSymbol: 'yGDX',
    fiatDecimals: 2,
    type: ASSETS_TYPES.STOCKS,
    icon: assets.gdx_icon,
    iconPng: assets.gdx_icon_png,
    icon2: '',
    icon2Png: '',
    color: '#17468F',
    games: ['lvg-stocks'],
    name: 'VanEck Gold Miners ETF (GDX) YOLOREKT Synthetic Stock',
    description:
      'The VanEck Vectors Gold Miners ETF is an exchange-traded fund that gives investors exposure to gold mining companies. The fund was established in May 2006 and trades on the NYSE Arca exchange. It is composed of 53 companies with $15.1 billion in total assets as of April 22, 2021.',
  },
  EFA: {
    id: 'EFA',
    uiName: 'yEFA',
    prodReady: true,
    hideInUi: false,
    hasTime: true,
    sqlDate: '2023-05-25',
    coinSymbol: 'yEFA',
    fiatDecimals: 2,
    type: ASSETS_TYPES.STOCKS,
    icon: assets.efa_icon,
    iconPng: assets.efa_icon_png,
    icon2: '',
    icon2Png: '',
    color: '#FF19C6',
    games: ['lvg-stocks'],
    name: 'iShares MSCI EAFE ETF YOLOREKT Synthetic Stock',
    description:
      'EFA tracks a market-cap-weighted index of developed-market securities based in Europe, Australia and the Far East. It excludes the US and Canada, and small-caps.',
  },
  SPXS: {
    id: 'SPXS',
    uiName: 'ySPXS',
    prodReady: true,
    hideInUi: false,
    hasTime: true,
    sqlDate: '2023-05-25',
    coinSymbol: 'ySPXS',
    fiatDecimals: 2,
    type: ASSETS_TYPES.STOCKS,
    icon: assets.spxs_icon,
    iconPng: assets.spxs_icon_png,
    icon2: '',
    icon2Png: '',
    color: '#7E868C',
    games: ['lvg-stocks'],
    name: 'Direxion Daily S&P 500 Bear 3X Shares YOLOREKT Synthetic Stock',
    description:
      'SPXS provides 3x inverse exposure to a market-cap-weighted index of 500 large- and mid-cap US companies selected by the S&P Committee. The listed name for SPXS is Direxion Daily S&P 500 Bear 3x Shares. ySPXS is a synthetic derivative created by YOLOREKT. The price of this synthetic derivative moves in the same way as the underlying asset(s).',
  },
  VEA: {
    id: 'VEA',
    uiName: 'yVEA',
    prodReady: true,
    hideInUi: false,
    hasTime: true,
    sqlDate: '2023-05-25',
    coinSymbol: 'yVEA',
    fiatDecimals: 2,
    type: ASSETS_TYPES.STOCKS,
    icon: assets.vea_icon,
    iconPng: assets.vea_icon_png,
    icon2: '',
    icon2Png: '',
    color: '#97151D',
    games: ['lvg-stocks'],
    name: 'Vanguard Developed Markets Index Fund (VEA) YOLOREKT Synthetic Stock',
    description:
      'VEA tracks a market-cap weighted index of large-, mid- and small-cap stocks from developed markets outside the US. yVEA is a synthetic derivative created by YOLOREKT. The price of this synthetic derivative moves in the same way as the underlying asset(s).',
  },
  LQD: {
    id: 'LQD',
    uiName: 'yLQD',
    prodReady: true,
    hideInUi: false,
    hasTime: true,
    sqlDate: '2023-05-25',
    coinSymbol: 'yLQD',
    fiatDecimals: 2,
    type: ASSETS_TYPES.STOCKS,
    icon: assets.lqd_icon,
    iconPng: assets.lqd_icon_png,
    icon2: '',
    icon2Png: '',
    color: '#973415',
    games: ['lvg-stocks'],
    name: 'iShares iBoxx $ Investment Grade Corporate Bond ETF YOLOREKT Synthetic Stock',
    description:
      'LQD tracks a market-weighted index of US corporate investment-grade bonds across the maturity spectrum. yLQD is a synthetic derivative created by YOLOREKT. The price of this synthetic derivative moves in the same way as the underlying asset(s).',
  },
  TLT: {
    id: 'TLT',
    uiName: 'yTLT',
    prodReady: true,
    hideInUi: false,
    hasTime: true,
    sqlDate: '2023-05-25',
    coinSymbol: 'yTLT',
    fiatDecimals: 2,
    type: ASSETS_TYPES.STOCKS,
    icon: assets.tlt_icon,
    iconPng: assets.tlt_icon_png,
    icon2: '',
    icon2Png: '',
    color: '#205266',
    games: ['lvg-stocks'],
    name: 'iShares 20+ Year Treasury Bond ETF YOLOREKT Synthetic Stock',
    description:
      'TLT tracks a market-weighted index of debt issued by the US Treasury with remaining maturities of 20 years or more. The listed name for TLT is iShares 20 Year Treasury Bond ETF. yTLT is a synthetic derivative created by YOLOREKT. The price of this synthetic derivative moves in the same way as the underlying asset(s).',
  },
  SLV: {
    id: 'SLV',
    uiName: 'ySLV',
    prodReady: true,
    hideInUi: false,
    hasTime: true,
    sqlDate: '2023-05-25',
    coinSymbol: 'ySLV',
    fiatDecimals: 2,
    type: ASSETS_TYPES.STOCKS,
    icon: assets.slv_icon,
    iconPng: assets.slv_icon_png,
    icon2: '',
    icon2Png: '',
    color: '#DD6002',
    games: ['lvg-stocks'],
    name: 'iShares Silver Trust YOLOREKT Synthetic Stock',
    description:
      'SLV tracks the silver spot price, less expenses and liabilities, using silver bullion held in London. ySLV is a synthetic derivative created by YOLOREKT. The price of this synthetic derivative moves in the same way as the underlying asset(s).',
  },
  BBBY: {
    id: 'BBBY',
    uiName: 'yBBBY',
    prodReady: true,
    hideInUi: false,
    hasTime: true,
    sqlDate: '2023-05-25',
    coinSymbol: 'yBBBY',
    fiatDecimals: 2,
    type: ASSETS_TYPES.STOCKS,
    icon: assets.bbby_icon,
    iconPng: assets.bbby_icon_png,
    icon2: '',
    icon2Png: '',
    color: '#1B4E8A',
    games: ['lvg-stocks'],
    name: 'Bed Bath & Beyond Inc. YOLOREKT Synthetic Stock',
    description:
      'Bed Bath & Beyond Inc., together with its subsidiaries, operates a chain of retail stores. It sells a range of domestics merchandise, including bed linens and related items, bath items, and kitchen textiles; and home furnishings, such as kitchen and tabletop items, fine tabletop, basic housewares, general home furnishings, consumables, and various juvenile products. yBBBY is a synthetic derivative created by YOLOREKT. The price of this synthetic derivative moves in the same way as the underlying asset(s).',
  },
  HOOD: {
    id: 'HOOD',
    uiName: 'yHOOD',
    prodReady: true,
    hideInUi: false,
    hasTime: true,
    sqlDate: '2023-05-25',
    coinSymbol: 'yHOOD',
    fiatDecimals: 2,
    type: ASSETS_TYPES.STOCKS,
    icon: assets.hood_icon,
    iconPng: assets.hood_icon_png,
    icon2: '',
    icon2Png: '',
    color: '#07CB00',
    games: ['lvg-stocks'],
    name: 'Robinhood Markets Inc. YOLOREKT Synthetic Stock',
    description:
      'Robinhood Markets, Inc is a financial services platform that pioneered commission-free stock trading with no account minimums and fractional share trading. The firm is focused on providing retail brokerage and offers trading in U.S. listed stocks and Exchange Traded Funds, related options, and cryptocurrency trading, as well as cash management, which includes debit cards services. yHOOD is a synthetic derivative created by YOLOREKT. The price of this synthetic derivative moves in the same way as the underlying asset(s).',
  },
  DIS: {
    id: 'DIS',
    uiName: 'yDIS',
    prodReady: true,
    hideInUi: false,
    hasTime: true,
    sqlDate: '2023-05-25',
    coinSymbol: 'yDIS',
    fiatDecimals: 2,
    type: ASSETS_TYPES.STOCKS,
    icon: assets.dis_icon,
    iconPng: assets.dis_icon_png,
    icon2: '',
    icon2Png: '',
    color: '#02147C',
    games: ['lvg-stocks'],
    name: 'The Walt Disney Company YOLOREKT Synthetic Stock',
    description:
      'The Walt Disney Company, together with its subsidiaries, operates as an entertainment company worldwide. It operates through two segments, Disney Media and Entertainment Distribution; and Disney Parks, Experiences and Products. yDIS is a synthetic derivative created by YOLOREKT. The price of this synthetic derivative moves in the same way as the underlying asset(s).',
  },
  ZM: {
    id: 'ZM',
    uiName: 'yZM',
    prodReady: true,
    hideInUi: false,
    hasTime: true,
    sqlDate: '2023-05-25',
    coinSymbol: 'yZM',
    fiatDecimals: 2,
    type: ASSETS_TYPES.STOCKS,
    icon: assets.zm_icon,
    iconPng: assets.zm_icon_png,
    icon2: '',
    icon2Png: '',
    color: '#2D8CFF',
    games: ['lvg-stocks'],
    name: 'Zoom Video Communications, Inc. YOLOREKT Synthetic Stock',
    description:
      'Zoom Video Communications, Inc. provides unified communications platform in the Americas, the Asia Pacific, Europe, the Middle East, and Africa. The company offers Zoom Meetings that offers HD video, voice, chat, and content sharing through mobile devices, desktops, laptops, telephones, and conference room systems. yZM is a synthetic derivative created by YOLOREKT. The price of this synthetic derivative moves in the same way as the underlying asset(s).',
  },
  PYPL: {
    id: 'PYPL',
    uiName: 'yPYPL',
    prodReady: true,
    hideInUi: false,
    hasTime: true,
    sqlDate: '2023-05-25',
    coinSymbol: 'yPYPL',
    fiatDecimals: 2,
    type: ASSETS_TYPES.STOCKS,
    icon: assets.pypl_icon,
    iconPng: assets.pypl_icon_png,
    icon2: '',
    icon2Png: '',
    color: '#003087',
    games: ['lvg-stocks'],
    name: 'PayPal Holdings Inc. YOLOREKT Synthetic Stock',
    description:
      'PayPal Holdings, Inc. operates a technology platform that enables digital payments on behalf of merchants and consumers worldwide. It provides payment solutions under the PayPal, PayPal Credit, Braintree, Venmo, Xoom, PayPal Zettle, Hyperwallet, PayPal Honey, and Paidy names. yPYPL is a synthetic derivative created by YOLOREKT. The price of this synthetic derivative moves in the same way as the underlying asset(s).',
  },
  DKNG: {
    id: 'DKNG',
    uiName: 'yDKNG',
    prodReady: true,
    hideInUi: false,
    hasTime: true,
    sqlDate: '2023-05-25',
    coinSymbol: 'yDKNG',
    fiatDecimals: 2,
    type: ASSETS_TYPES.STOCKS,
    icon: assets.dkng_icon,
    iconPng: assets.dkng_icon_png,
    icon2: '',
    icon2Png: '',
    color: '#61B510',
    games: ['lvg-stocks'],
    name: 'DraftKings Inc. YOLOREKT Synthetic Stock',
    description:
      'DraftKings Inc. operates a digital sports entertainment and gaming company. It offers multi-channel sports betting and gaming technologies, powering sports and gaming entertainment for operators in 17 countries. yDKNG is a synthetic derivative created by YOLOREKT. The price of this synthetic derivative moves in the same way as the underlying asset(s).',
  },
  UBER: {
    id: 'UBER',
    uiName: 'yUBER',
    prodReady: true,
    hideInUi: false,
    hasTime: true,
    sqlDate: '2023-05-25',
    coinSymbol: 'yUBER',
    fiatDecimals: 2,
    type: ASSETS_TYPES.STOCKS,
    icon: assets.uber_icon,
    iconPng: assets.uber_icon_png,
    icon2: '',
    icon2Png: '',
    color: '#000000',
    games: ['lvg-stocks'],
    name: 'Uber Technologies Inc. YOLOREKT Synthetic Stock',
    description:
      'Uber Technologies, Inc. develops and operates proprietary technology applications in the United States, Canada, Latin America, Europe, the Middle East, Africa, and Asia excluding China and Southeast Asia. It operates through three segments: Mobility, Delivery, and Freight. yUBER is a synthetic derivative created by YOLOREKT. The price of this synthetic derivative moves in the same way as the underlying asset(s).',
  },
  BABA: {
    id: 'BABA',
    uiName: 'yBABA',
    prodReady: true,
    hideInUi: false,
    hasTime: true,
    sqlDate: '2023-05-25',
    coinSymbol: 'yBABA',
    fiatDecimals: 2,
    type: ASSETS_TYPES.STOCKS,
    icon: assets.baba_icon,
    iconPng: assets.baba_icon_png,
    icon2: '',
    icon2Png: '',
    color: '#FF6B00',
    games: ['lvg-stocks'],
    name: 'Alibaba Group Holding Limited YOLOREKT Synthetic Stock',
    description:
      "Alibaba Group Holding Limited, through its subsidiaries, provides technology infrastructure and marketing reach to help merchants, brands, retailers, and other businesses to engage with their users and customers in the People's Republic of China and internationally. yBABA is a synthetic derivative created by YOLOREKT. The price of this synthetic derivative moves in the same way as the underlying asset(s).",
  },
  PLTR: {
    id: 'PLTR',
    uiName: 'yPLTR',
    prodReady: true,
    hideInUi: false,
    hasTime: true,
    sqlDate: '2023-05-25',
    coinSymbol: 'yPLTR',
    fiatDecimals: 2,
    type: ASSETS_TYPES.STOCKS,
    icon: assets.pltr_icon,
    iconPng: assets.pltr_icon_png,
    icon2: '',
    icon2Png: '',
    color: '#DDDDDD',
    games: ['lvg-stocks'],
    name: 'Palantir Technologies Inc. YOLOREKT Synthetic Stock',
    description:
      'Palantir Technologies Inc. builds and deploys software platforms for the intelligence community in the United States to assist in counterterrorism investigations and operations. yPLTR is a synthetic derivative created by YOLOREKT. The price of this synthetic derivative moves in the same way as the underlying asset(s).',
  },
  GME: {
    id: 'GME',
    uiName: 'yGME',
    prodReady: true,
    hideInUi: false,
    hasTime: true,
    sqlDate: '2023-05-25',
    coinSymbol: 'yGME',
    fiatDecimals: 2,
    type: ASSETS_TYPES.STOCKS,
    icon: assets.gme_icon,
    iconPng: assets.gme_icon_png,
    icon2: '',
    icon2Png: '',
    color: '#ED3527',
    games: ['lvg-stocks'],
    name: 'GameStop Corp. YOLOREKT Synthetic Stock',
    description:
      'GameStop Corp., a specialty retailer, provides games and entertainment products through its e-commerce properties and various stores in the United States, Canada, Australia, and Europe. yGME is a synthetic derivative created by YOLOREKT. The price of this synthetic derivative moves in the same way as the underlying asset(s).',
  },
  TGT: {
    id: 'TGT',
    uiName: 'yTGT',
    prodReady: true,
    hideInUi: false,
    hasTime: true,
    sqlDate: '2023-05-25',
    coinSymbol: 'yTGT',
    fiatDecimals: 2,
    type: ASSETS_TYPES.STOCKS,
    icon: assets.tgt_icon,
    iconPng: assets.tgt_icon_png,
    icon2: '',
    icon2Png: '',
    color: '#CC0200',
    games: ['lvg-stocks'],
    name: 'Target Corporation YOLOREKT Synthetic Stock',
    description:
      'Target Corporation operates as a general merchandise retailer in the United States. The company offers food assortments, including perishables, dry grocery, dairy, and frozen items; apparel, accessories, home décor products, electronics, toys, seasonal offerings, food, and other merchandise; and beauty and household essentials. yTGT is a synthetic derivative created by YOLOREKT. The price of this synthetic derivative moves in the same way as the underlying asset(s).',
  },
  NFLX: {
    id: 'NFLX',
    uiName: 'yNFLX',
    prodReady: true,
    hideInUi: false,
    hasTime: true,
    sqlDate: '2023-05-25',
    coinSymbol: 'yNFLX',
    fiatDecimals: 2,
    type: ASSETS_TYPES.STOCKS,
    icon: assets.nflx_icon,
    iconPng: assets.nflx_icon_png,
    icon2: '',
    icon2Png: '',
    color: '#E60814',
    games: ['lvg-stocks'],
    name: 'Netflix Inc. YOLOREKT Synthetic Stock',
    description:
      'Netflix, Inc. provides entertainment services. It offers TV series, documentaries, feature films, and mobile games across various genres and languages. The company provides members the ability to receive streaming content through a host of internet-connected devices, including TVs, digital video players, television set-top boxes, and mobile devices. yNFLX is a synthetic derivative created by YOLOREKT. The price of this synthetic derivative moves in the same way as the underlying asset(s).',
  },
  JPM: {
    id: 'JPM',
    uiName: 'yJPM',
    prodReady: true,
    hideInUi: false,
    hasTime: true,
    sqlDate: '2023-05-25',
    coinSymbol: 'yJPM',
    fiatDecimals: 2,
    type: ASSETS_TYPES.STOCKS,
    icon: assets.jpm_icon,
    iconPng: assets.jpm_icon_png,
    icon2: '',
    icon2Png: '',
    color: '#0A0C0C',
    games: ['lvg-stocks'],
    name: 'JPMorgan Chase & Co. YOLOREKT Synthetic Stock',
    description:
      'JPMorgan Chase & Co. operates as a financial services company worldwide. It operates through four segments: Consumer & Community Banking (CCB), Corporate & Investment Bank (CIB), Commercial Banking (CB), and Asset & Wealth Management (AWM). yJPM is a synthetic derivative created by YOLOREKT. The price of this synthetic derivative moves in the same way as the underlying asset(s).',
  },
  GS: {
    id: 'GS',
    uiName: 'yGS',
    prodReady: true,
    hideInUi: false,
    hasTime: true,
    sqlDate: '2023-05-25',
    coinSymbol: 'yGS',
    fiatDecimals: 2,
    type: ASSETS_TYPES.STOCKS,
    icon: assets.gs_icon,
    iconPng: assets.gs_icon_png,
    icon2: '',
    icon2Png: '',
    color: '#192E47',
    games: ['lvg-stocks'],
    name: 'The Goldman Sachs Group Inc. YOLOREKT Synthetic Stock',
    description:
      'The Goldman Sachs Group, Inc., a financial institution, provides a range of financial services for corporations, financial institutions, governments, and individuals worldwide. It operates through Global Banking & Markets, Asset & Wealth Management, and Platform Solutions segments. yGS is a synthetic derivative created by YOLOREKT. The price of this synthetic derivative moves in the same way as the underlying asset(s).',
  },
  BAC: {
    id: 'BAC',
    uiName: 'yBAC',
    prodReady: true,
    hideInUi: false,
    hasTime: true,
    sqlDate: '2023-05-25',
    coinSymbol: 'yBAC',
    fiatDecimals: 2,
    type: ASSETS_TYPES.STOCKS,
    icon: assets.bac_icon,
    iconPng: assets.bac_icon_png,
    icon2: '',
    icon2Png: '',
    color: '#E31937',
    games: ['lvg-stocks'],
    name: 'Bank of America Corporation YOLOREKT Synthetic Stock',
    description:
      'Bank of America Corporation, through its subsidiaries, provides banking and financial products and services for individual consumers, small and middle-market businesses, institutional investors, large corporations, and governments worldwide. yBAC is a synthetic derivative created by YOLOREKT. The price of this synthetic derivative moves in the same way as the underlying asset(s).',
  },
  WFC: {
    id: 'WFC',
    uiName: 'yWFC',
    prodReady: true,
    hideInUi: false,
    hasTime: true,
    sqlDate: '2023-05-25',
    coinSymbol: 'yWFC',
    fiatDecimals: 2,
    type: ASSETS_TYPES.STOCKS,
    icon: assets.wfc_icon,
    iconPng: assets.wfc_icon_png,
    icon2: '',
    icon2Png: '',
    color: '#D71F28',
    games: ['lvg-stocks'],
    name: 'Wells Fargo & Company YOLOREKT Synthetic Stock',
    description:
      'Wells Fargo & Company, a diversified financial services company, provides banking, investment, mortgage, and consumer and commercial finance products and services in the United States and internationally. yWFC is a synthetic derivative created by YOLOREKT. The price of this synthetic derivative moves in the same way as the underlying asset(s).',
  },
  C: {
    id: 'C',
    uiName: 'yC',
    prodReady: true,
    hideInUi: false,
    hasTime: true,
    sqlDate: '2023-05-25',
    coinSymbol: 'yC',
    fiatDecimals: 2,
    type: ASSETS_TYPES.STOCKS,
    icon: assets.c_icon,
    iconPng: assets.c_icon_png,
    icon2: '',
    icon2Png: '',
    color: '#002D72',
    games: ['lvg-stocks'],
    name: 'Citigroup Inc. YOLOREKT Synthetic Stock',
    description:
      'Citigroup Inc., a diversified financial services holding company, provides various financial products and services to consumers, corporations, governments, and institutions in North America, Latin America, Asia, Europe, the Middle East, and Africa. yC is a synthetic derivative created by YOLOREKT. The price of this synthetic derivative moves in the same way as the underlying asset(s).',
  },
  MS: {
    id: 'MS',
    uiName: 'yMS',
    prodReady: true,
    hideInUi: false,
    hasTime: true,
    sqlDate: '2023-05-25',
    coinSymbol: 'yMS',
    fiatDecimals: 2,
    type: ASSETS_TYPES.STOCKS,
    icon: assets.ms_icon,
    iconPng: assets.ms_icon_png,
    icon2: '',
    icon2Png: '',
    color: '#177ABA',
    games: ['lvg-stocks'],
    name: 'Morgan Stanley YOLOREKT Synthetic Stock',
    description:
      'Morgan Stanley, a financial holding company, provides various financial products and services to corporations, governments, financial institutions, and individuals in the Americas, Europe, the Middle East, Africa, and Asia. It operates through Institutional Securities, Wealth Management, and Investment Management segments. yMS is a synthetic derivative created by YOLOREKT. The price of this synthetic derivative moves in the same way as the underlying asset(s).',
  },
  COF: {
    id: 'COF',
    uiName: 'yCOF',
    prodReady: true,
    hideInUi: false,
    hasTime: true,
    sqlDate: '2023-05-25',
    coinSymbol: 'yCOF',
    fiatDecimals: 2,
    type: ASSETS_TYPES.STOCKS,
    icon: assets.cof_icon,
    iconPng: assets.cof_icon_png,
    icon2: '',
    icon2Png: '',
    color: '#CC2427',
    games: ['lvg-stocks'],
    name: 'Capital One Financial Corporation YOLOREKT Synthetic Stock',
    description:
      'Capital One Financial Corporation operates as the financial services holding company for the Capital One Bank (USA), National Association; and Capital One, National Association, which provides various financial products and services in the United States, Canada, and the United Kingdom. yCOF is a synthetic derivative created by YOLOREKT. The price of this synthetic derivative moves in the same way as the underlying asset(s).',
  },
  NKE: {
    id: 'NKE',
    uiName: 'yNKE',
    prodReady: true,
    hideInUi: false,
    hasTime: true,
    sqlDate: '2023-05-25',
    coinSymbol: 'yNKE',
    fiatDecimals: 2,
    type: ASSETS_TYPES.STOCKS,
    icon: assets.nke_icon,
    iconPng: assets.nke_icon_png,
    icon2: '',
    icon2Png: '',
    color: '#000000',
    games: ['lvg-stocks'],
    name: 'NIKE Inc. YOLOREKT Synthetic Stock',
    description:
      'NIKE, Inc., together with its subsidiaries, designs, develops, markets, and sells men’s, women’s, and kids athletic footwear, apparel, equipment, and accessories worldwide. yNKE is a synthetic derivative created by YOLOREKT. The price of this synthetic derivative moves in the same way as the underlying asset(s).',
  },
  FCNCA: {
    id: 'FCNCA',
    uiName: 'yFCNCA',
    prodReady: true,
    hideInUi: false,
    hasTime: true,
    sqlDate: '2023-05-25',
    coinSymbol: 'yFCNCA',
    fiatDecimals: 2,
    type: ASSETS_TYPES.STOCKS,
    icon: assets.fcnca_icon,
    iconPng: assets.fcnca_icon_png,
    icon2: '',
    icon2Png: '',
    color: '#00A7CD',
    games: ['lvg-stocks'],
    name: 'First Citizens BancShares, Inc. YOLOREKT Synthetic Stock',
    description:
      "First Citizens BancShares, Inc. operates as the holding company for First-Citizens Bank & Trust Company that provides retail and commercial banking services to individuals, businesses, and professionals. The company's deposit products include checking, savings, money market, and time deposit accounts. yFCNCA is a synthetic derivative created by YOLOREKT. The price of this synthetic derivative moves in the same way as the underlying asset(s).",
  },
  NVDA: {
    id: 'NVDA',
    uiName: 'yNVDA',
    prodReady: true,
    hideInUi: false,
    hasTime: true,
    sqlDate: '2023-05-24',
    coinSymbol: 'yNVDA',
    fiatDecimals: 2,
    type: ASSETS_TYPES.STOCKS,
    icon: assets.nvda_icon,
    iconPng: assets.nvda_icon_png,
    icon2: '',
    icon2Png: '',
    color: '#76B900',
    games: ['lvg-stocks'],
    name: 'NVIDIA Corporation YOLOREKT Synthetic Stock',
    description:
      'Nvidia designs and sells GPUs for gaming, cryptocurrency mining, and professional applications, as well as chip systems for use in vehicles, robotics, and other tools. yNVIDIA is a synthetic derivative created by YOLOREKT. The price of this synthetic derivative moves in the same way as the underlying asset(s).',
  },
  TSLA: {
    id: 'TSLA',
    uiName: 'yTSLA',
    prodReady: true,
    hideInUi: false,
    hasTime: true,
    sqlDate: '2023-05-22',
    coinSymbol: 'yTSLA',
    fiatDecimals: 2,
    type: ASSETS_TYPES.STOCKS,
    icon: assets.tsla_icon,
    iconPng: assets.tsla_icon_png,
    icon2: '',
    icon2Png: '',
    color: '#C80200',
    games: ['lvg-stocks'],
    name: 'Tesla Inc. YOLOREKT Synthetic Stock',
    description:
      'Tesla, Inc. designs, develops, manufactures, leases, and sells electric vehicles, and energy generation and storage systems in the United States, China, and internationally. It operates in two segments, Automotive, and Energy Generation and Storage. yTSLA is a synthetic derivative created by YOLOREKT. The price of this synthetic derivative moves in the same way as the underlying asset(s).',
  },
  SPY: {
    id: 'SPY',
    uiName: 'ySPY',
    prodReady: true,
    hideInUi: false,
    hasTime: true,
    sqlDate: '2023-05-22',
    coinSymbol: 'ySPY',
    fiatDecimals: 2,
    type: ASSETS_TYPES.STOCKS,
    icon: assets.spy_icon,
    iconPng: assets.spy_icon_png,
    icon2: '',
    icon2Png: '',
    color: '#13A96C',
    games: ['lvg-stocks'],
    name: 'SPDR S&P 500 ETF Trust YOLOREKT Synthetic Stock',
    description:
      'SPY is the ticker symbol for the SPDR® S&P 500® ETF, an exchange traded fund that tracks the performance of the S&P 500® Index. SPY, managed State Street Global Advisors, aims to replicate the performance of the S&P 500® Index as closely as possible by investing in the same stocks that are included in the index in the same weightings. SPY is traded on the New York Stock Exchange (NYSE Arca) and is highly liquid, making it a popular choice for investors looking to gain broad exposure to the US stock market. ySPY is a synthetic derivative created by YOLOREKT. The price of this synthetic derivative moves in the same way as the underlying asset(s).',
  },
  AMZN: {
    id: 'AMZN',
    uiName: 'yAMZN',
    prodReady: true,
    hideInUi: false,
    hasTime: true,
    sqlDate: '2023-05-22',
    coinSymbol: 'yAMZN',
    fiatDecimals: 2,
    type: ASSETS_TYPES.STOCKS,
    icon: assets.amzn_icon,
    iconPng: assets.amzn_icon_png,
    icon2: '',
    icon2Png: '',
    color: '#FB9908',
    games: ['lvg-stocks'],
    name: 'Amazon Inc. YOLOREKT Synthetic Stock',
    description:
      'Amazon.com Inc (Amazon) is an online retailer and web service provider. The company provides products such as apparel, auto and industrial items, beauty and health products, electronics, grocery, books, games, jewellery, kids and baby products, movies, music, sports goods, toys, tools and other related products. yAMZN is a synthetic derivative created by YOLOREKT. The price of this synthetic derivative moves in the same way as the underlying asset(s).',
  },
  GOOGL: {
    id: 'GOOGL',
    uiName: 'yGOOGL',
    prodReady: true,
    hideInUi: false,
    hasTime: true,
    sqlDate: '2023-05-22',
    coinSymbol: 'yGOOGL',
    fiatDecimals: 2,
    type: ASSETS_TYPES.STOCKS,
    icon: assets.googl_icon,
    iconPng: assets.googl_icon_png,
    icon2: '',
    icon2Png: '',
    color: '#ED1E25',
    games: ['lvg-stocks'],
    name: 'Google Inc. YOLOREKT Synthetic Stock',
    description:
      'Google LLC (Google), a subsidiary of Alphabet Inc, is a provider of search and advertising services on the internet. The company focuses on various business areas such as advertising, search, platforms and operating systems, and enterprise and hardware products. yGOOGL is a synthetic derivative created by YOLOREKT. The price of this synthetic derivative moves in the same way as the underlying asset(s).',
  },
  AAPL: {
    id: 'AAPL',
    uiName: 'yAAPL',
    prodReady: true,
    hideInUi: false,
    hasTime: true,
    sqlDate: '2023-05-22',
    coinSymbol: 'yAAPL',
    fiatDecimals: 2,
    type: ASSETS_TYPES.STOCKS,
    icon: assets.aapl_icon,
    iconPng: assets.aapl_icon_png,
    icon2: '',
    icon2Png: '',
    color: '#000000',
    games: ['lvg-stocks'],
    name: 'Apple Inc. YOLOREKT Synthetic Stock',
    description:
      'Apple Inc. is an American multinational technology company headquartered in Cupertino, California, United States. yAAPL is a synthetic derivative created by YOLOREKT. The price of this synthetic derivative moves in the same way as the underlying asset(s).',
  },
  'RNDR/USD': {
    id: 'RNDR/USD',
    uiName: 'RNDR/USD',
    prodReady: true,
    hideInUi: false,
    hasTime: false,
    sqlDate: '2023-05-22',
    coinSymbol: 'RNDR',
    fiatDecimals: 6,
    type: ASSETS_TYPES.CRYPTO,
    icon: assets.rndr_icon,
    iconPng: assets.rndr_icon_png,
    icon2: '',
    icon2Png: '',
    color: '#C80F11',
    games: ['lvg-crypto'],
    name: 'Render Token (RNDR)',
    description:
      'Render Token (RNDR) is the utility token of The Render Network, a provider of decentralized GPU based rendering solutions. RNDR is an ERC-20 token which serves as the utility token used to pay for animation, motion graphics, and VFX rendering on the Render Network.',
  },
  'KDA/USD': {
    id: 'KDA/USD',
    uiName: 'KDA/USD',
    prodReady: true,
    hideInUi: true,
    hasTime: false,
    sqlDate: '2023-05-12',
    coinSymbol: 'KDA',
    fiatDecimals: 6,
    type: ASSETS_TYPES.CRYPTO,
    icon: assets.kda_icon,
    iconPng: assets.kda_icon_png,
    icon2: '',
    icon2Png: '',
    color: '#69009A',
    games: ['lvg-crypto'],
    name: 'Kadena (KDA)',
    description:
      'Kadena (KDA) is a digital currency that is used to pay for compute on the Kadena public chain. Similar to ETH on Ethereum, KDA on Kadena is the manner by which miners are compensated for mining blocks on the network and is the transaction fee that users pay in order to have their transactions included in a block.',
  },
  'INJ/USD': {
    id: 'INJ/USD',
    uiName: 'INJ/USD',
    prodReady: true,
    hideInUi: false,
    hasTime: false,
    sqlDate: '2023-05-12',
    coinSymbol: 'INJ',
    fiatDecimals: 6,
    type: ASSETS_TYPES.CRYPTO,
    icon: assets.inj_icon,
    iconPng: assets.inj_icon_png,
    icon2: '',
    icon2Png: '',
    color: '#00ACFC',
    games: ['lvg-crypto'],
    name: 'Injective (INJ)',
    description:
      'Injective (INJ) is a decentralized exchange (DEX) that offers cross-chain margin trading, derivatives and forex futures trading. The Injective Protocol is built on the Cosmos blockchain as a Layer 2 application.',
  },
  '1000PEPE/USD': {
    id: '1000PEPE/USD',
    uiName: '1000PEPE/USD',
    prodReady: true,
    hideInUi: false,
    hasTime: false,
    sqlDate: '2023-05-11',
    coinSymbol: '1000PEPE',
    fiatDecimals: 7,
    type: ASSETS_TYPES.MEME_COIN,
    icon: assets.pepe_icon,
    iconPng: assets.pepe_icon_png,
    icon2: '',
    icon2Png: '',
    color: '#14831F',
    games: ['lvg-crypto'],
    name: 'Pepe (PEPE)',
    description:
      'Pepe (PEPE) is a meme coin with no intrinsic value or expectation of financial return. There is no formal team or roadmap. The coin is completely useless and for entertainment purposes only.',
  },
  '10000LADYS/USD': {
    id: '10000LADYS/USD',
    uiName: '10000LADYS/USD',
    prodReady: true,
    hideInUi: false,
    hasTime: false,
    sqlDate: '2023-05-11',
    coinSymbol: '10000LADYS',
    fiatDecimals: 7,
    type: ASSETS_TYPES.MEME_COIN,
    icon: assets.ladys_icon,
    iconPng: assets.ladys_icon_png,
    icon2: '',
    icon2Png: '',
    color: '#6B453B',
    games: ['lvg-crypto'],
    name: 'Milady Meme Coin (LADYS)',
    description:
      'Milady Meme Coin (LADYS) is a memecoin based on the Milady NFT collection and is used purely for entertainment purposes. The value or use of LADYS depends on community support and the general state of the cryptocurrency market.',
  },
  '1000FLOKI/USD': {
    id: '1000FLOKI/USD',
    uiName: '1000FLOKI/USD',
    prodReady: true,
    hideInUi: false,
    hasTime: false,
    sqlDate: '2023-05-11',
    coinSymbol: '1000FLOKI',
    fiatDecimals: 6,
    type: ASSETS_TYPES.MEME_COIN,
    icon: assets.floki_icon,
    iconPng: assets.floki_icon_png,
    icon2: '',
    icon2Png: '',
    color: '#F79421',
    games: ['lvg-crypto'],
    name: 'Floki (FLOKI)',
    description:
      'Floki (FLOKI) is a multi-chain token, allowing it to be used on the Ethereum and Binance Smart Chain (BSC) platforms. The Floki ecosystem has an array of existing and upcoming products which could potentially add value to the token. The project has partnered with other reputable projects in the industry.',
  },
  'MONG/USD': {
    id: 'MONG/USD',
    uiName: 'MONG/USD',
    prodReady: false,
    hideInUi: false,
    hasTime: false,
    sqlDate: '2023-05-09',
    coinSymbol: 'MONG',
    fiatDecimals: 8,
    type: ASSETS_TYPES.MEME_COIN,
    icon: assets.mong_icon,
    iconPng: assets.mong_icon_png,
    icon2: '',
    icon2Png: '',
    color: '#7B18F6',
    games: ['lvg-crypto'],
    name: 'MongCoin (MONG)',
    description:
      'MongCoin (MONG) was born out of the incoherent ramblings of a US congressman. Mongs are immortal, surviving both rugs, and bear markets. They value friendship, degenerate meme culture, and good vibes. If you align with these values grab some $MONG and welcome to the mob.',
  },
  'WOJAK/USD': {
    id: 'WOJAK/USD',
    uiName: 'WOJAK/USD',
    prodReady: true,
    hideInUi: true,
    hasTime: false,
    sqlDate: '#VALUE!',
    coinSymbol: 'WOJAK',
    fiatDecimals: 5,
    type: ASSETS_TYPES.MEME_COIN,
    icon: assets.wojak_icon,
    iconPng: assets.wojak_icon_png,
    icon2: '',
    icon2Png: '',
    color: '#14831F',
    games: ['lvg-crypto'],
    name: 'Wojack (WOJAK)',
    description:
      'Wojak (WOJAK) is a cryptoasset project that aims to create a decentralized platform for connecting people through the power of memes. The project is inspired by the popular internet meme of the same name, which represents a cartoonish face expressing a range of emotions.',
  },
  'BLUR/USD': {
    id: 'BLUR/USD',
    uiName: 'BLUR/USD',
    prodReady: true,
    hideInUi: false,
    hasTime: false,
    sqlDate: '2023-05-01',
    coinSymbol: 'BLUR',
    fiatDecimals: 3,
    type: ASSETS_TYPES.CRYPTO,
    icon: assets.blur_icon,
    iconPng: assets.blur_icon_png,
    icon2: '',
    icon2Png: '',
    color: '#F36925',
    games: ['lvg-crypto'],
    name: 'Blur (BLUR)',
    description:
      'Blur (BLUR) is an Ethereum-based digital marketplace that stands out among other platforms in the NFT market. It is a marketplace aggregator and offers advanced analytics, excellent portfolio management capabilities, and the ability to compare NFTs on multiple marketplaces.',
  },
  YOLOCOASTER: {
    id: 'YOLOCOASTER',
    uiName: 'YOLOCOASTER',
    prodReady: true,
    hideInUi: false,
    hasTime: false,
    sqlDate: '2023-04-25',
    coinSymbol: 'YOLOCOASTER',
    fiatDecimals: 2,
    type: ASSETS_TYPES.CRYPTO,
    icon: assets.yolocoaster_icon,
    iconPng: assets.yolocoaster_icon_png,
    icon2: '',
    icon2Png: '',
    color: '#1CA737',
    games: ['lvg-crypto'],
    name: 'YOLOCOASTER (YC)',
    description:
      'YOLOCOASTER (YOLOCOASTER) is a new category of crypto asset, created by YOLOREKT, dubbed “gamified crypto”. It’s based on randomly generated prices with consistent volatility, and extremely fun and effective for high leverage.',
  },
  'FLOKI/USD': {
    id: 'FLOKI/USD',
    uiName: 'FLOKI/USD',
    prodReady: false,
    hideInUi: false,
    hasTime: false,
    sqlDate: '2023-04-25',
    coinSymbol: 'FLOKI',
    fiatDecimals: 4,
    type: ASSETS_TYPES.MEME_COIN,
    icon: assets.floki_icon,
    iconPng: assets.floki_icon_png,
    icon2: '',
    icon2Png: '',
    color: '#F79421',
    games: ['lvg-crypto'],
    name: 'Floki (FLOKI)',
    description:
      'Floki (FLOKI) is a multi-chain token, allowing it to be used on the Ethereum and Binance Smart Chain (BSC) platforms. The Floki ecosystem has an array of existing and upcoming products which could potentially add value to the token. The project has partnered with other reputable projects in the industry.',
  },
  'FTM/USD': {
    id: 'FTM/USD',
    uiName: 'FTM/USD',
    prodReady: true,
    hideInUi: true,
    hasTime: false,
    sqlDate: '2023-04-24',
    coinSymbol: 'FTM',
    fiatDecimals: 5,
    type: ASSETS_TYPES.CRYPTO,
    icon: assets.ftm_icon,
    iconPng: assets.ftm_icon_png,
    icon2: '',
    icon2Png: '',
    color: '#1869FF',
    games: ['lvg-crypto'],
    name: 'Fantom (FTM)',
    description:
      'Fantom (FTM) is a decentralized, permissionless, open-source smart contract platform for decentralized applications (dApps) and digital assets — one of many blockchain networks built to provide an alternative to Ethereum.',
  },
  'PEPE/USD': {
    id: 'PEPE/USD',
    uiName: 'PEPE/USD',
    prodReady: true,
    hideInUi: true,
    hasTime: false,
    sqlDate: '2023-04-20',
    coinSymbol: 'PEPE',
    fiatDecimals: 11,
    type: ASSETS_TYPES.MEME_COIN,
    icon: assets.pepe_icon,
    iconPng: assets.pepe_icon_png,
    icon2: '',
    icon2Png: '',
    color: '#14831F',
    games: ['lvg-crypto'],
    name: 'Pepe (PEPE)',
    description:
      'Pepe (PEPE) is a meme coin with no intrinsic value or expectation of financial return. There is no formal team or roadmap. The coin is completely useless and for entertainment purposes only.',
  },
  DINO: {
    id: 'DINO',
    uiName: 'DINO',
    prodReady: true,
    hideInUi: false,
    hasTime: false,
    sqlDate: '2023-04-20',
    coinSymbol: 'DINO',
    fiatDecimals: 5,
    type: ASSETS_TYPES.YOLO_ETF,
    icon: assets.dino_icon,
    iconPng: assets.dino_icon_png,
    icon2: '',
    icon2Png: '',
    color: '#009926',
    games: ['lvg-indexes'],
    name: 'yoloETF Old Native Coins Index (DINO)',
    description:
      'yoloETF Old Native Coins Index (DINO) is an experimental ETF which tracks the market cap-weighted index of <strong>LTC (Litecoin)</strong>, <strong>XRP (Ripple)</strong>, and <strong>DOGE (Dogecoin)</strong>, created by YOLOREKT.',
  },
  ALAMEDA: {
    id: 'ALAMEDA',
    uiName: 'ALAMEDA',
    prodReady: true,
    hideInUi: false,
    hasTime: false,
    sqlDate: '2023-04-20',
    coinSymbol: 'ALAMEDA',
    fiatDecimals: 5,
    type: ASSETS_TYPES.YOLO_ETF,
    icon: assets.alameda_icon,
    iconPng: assets.alameda_icon_png,
    icon2: '',
    icon2Png: '',
    color: '#000000',
    games: ['lvg-indexes'],
    name: 'yoloETF Newer Native Coins Index (ALAMEDA)',
    description:
      'yoloETF Newer Native Coins Index (ALAMEDA) is an experimental ETF which tracks the market cap-weighted index of <strong>SOL (Solana)</strong>, <strong>ADA (Cardano)</strong>, and <strong>APT (Aptos)</strong>, created by YOLOREKT.',
  },
  LIQME: {
    id: 'LIQME',
    uiName: 'LIQME',
    prodReady: true,
    hideInUi: false,
    hasTime: false,
    sqlDate: '2023-04-20',
    coinSymbol: 'LIQME',
    fiatDecimals: 5,
    type: ASSETS_TYPES.YOLO_ETF,
    icon: assets.liqme_icon,
    iconPng: assets.liqme_icon_png,
    icon2: '',
    icon2Png: '',
    color: '#469224',
    games: ['lvg-indexes'],
    name: 'yoloETF Perpetual Dex Coins Index (LIQME)',
    description:
      'yoloETF Perpetual Dex Coins Index (LIQME) is an experimental ETF which tracks the market cap-weighted index of <strong>GMX (GMX)</strong>, <strong>SNX (Synthetix)</strong>, and <strong>DYDX (dYdX)</strong>, created by YOLOREKT.',
  },
  SWAP: {
    id: 'SWAP',
    uiName: 'SWAP',
    prodReady: true,
    hideInUi: false,
    hasTime: false,
    sqlDate: '2023-04-20',
    coinSymbol: 'SWAP',
    fiatDecimals: 5,
    type: ASSETS_TYPES.YOLO_ETF,
    icon: assets.swap_icon,
    iconPng: assets.swap_icon_png,
    icon2: '',
    icon2Png: '',
    color: '#865CFF',
    games: ['lvg-indexes'],
    name: 'yoloETF Decentralized Exchange Coins Index (SWAP)',
    description:
      'yoloETF Decentralized Exchange Coins Index (SWAP) is an experimental ETF which tracks the market cap-weighted index of <strong>Curve DAO Token (CRV)</strong>, <strong>SushiSwap (SUSHI)</strong>, and <strong>Uniswap (UNI)</strong>, created by YOLOREKT.',
  },
  DGOV: {
    id: 'DGOV',
    uiName: 'DGOV',
    prodReady: true,
    hideInUi: false,
    hasTime: false,
    sqlDate: '2023-04-20',
    coinSymbol: 'DGOV',
    fiatDecimals: 5,
    type: ASSETS_TYPES.YOLO_ETF,
    icon: assets.dgov_icon,
    iconPng: assets.dgov_icon_png,
    icon2: '',
    icon2Png: '',
    color: '#579A44',
    games: ['lvg-indexes'],
    name: 'yoloETF Governance Tokens Index (DGOV)',
    description:
      'yoloETF Governance Tokens Index (DGOV) is an experimental ETF which tracks the market cap-weighted index of <strong>Maker (MKR)</strong>, <strong>Aave (AAVE)</strong>, and <strong>Compound (COMP)</strong>, created by YOLOREKT.',
  },
  'AAVE/USD': {
    id: 'AAVE/USD',
    uiName: 'AAVE/USD',
    prodReady: true,
    hideInUi: false,
    hasTime: false,
    sqlDate: '2023-04-19',
    coinSymbol: 'AAVE',
    fiatDecimals: 5,
    type: ASSETS_TYPES.CRYPTO,
    icon: assets.aave_icon,
    iconPng: assets.aave_icon_png,
    icon2: '',
    icon2Png: '',
    color: '#49A5BD',
    games: ['lvg-crypto'],
    name: 'Aave (AAVE)',
    description:
      'Aave (AAVE) is a decentralized crypto lending platform that lets users borrow and lend crypto. Aave uses smart contracts to automate the process. It specializes in overcollateralized loans that require users to deposit crypto worth more than the amount that they wish to borrow.',
  },
  'COMP/USD': {
    id: 'COMP/USD',
    uiName: 'COMP/USD',
    prodReady: true,
    hideInUi: true,
    hasTime: false,
    sqlDate: '2023-04-19',
    coinSymbol: 'COMP',
    fiatDecimals: 5,
    type: ASSETS_TYPES.CRYPTO,
    icon: assets.comp_icon,
    iconPng: assets.comp_icon_png,
    icon2: '',
    icon2Png: '',
    color: '#00D396',
    games: ['lvg-crypto'],
    name: 'Compound (COMP)',
    description:
      'Compound (COMP) allows users to deposit cryptocurrency into lending pools for access by borrowers. Lenders then earn interest on the assets they deposit. Once a deposit is made, Compound awards a new cryptocurrency called a cToken (which represents the deposit) to the lender.',
  },
  'UNI/USD': {
    id: 'UNI/USD',
    uiName: 'UNI/USD',
    prodReady: true,
    hideInUi: false,
    hasTime: false,
    sqlDate: '2023-04-19',
    coinSymbol: 'UNI',
    fiatDecimals: 5,
    type: ASSETS_TYPES.CRYPTO,
    icon: assets.uni_icon,
    iconPng: assets.uni_icon_png,
    icon2: '',
    icon2Png: '',
    color: '#FF007A',
    games: ['lvg-crypto'],
    name: 'Uniswap (UNI)',
    description:
      "Uniswap (UNI) is an Ethereum token that powers Uniswap, an automated liquidity provider that's designed to make it easy to exchange Ethereum (ERC-20) tokens. There is no orderbook or central facilitator on Uniswap. Instead, tokens are exchanged through liquidity pools that are defined by smart contracts.",
  },
  'BIT/USD': {
    id: 'BIT/USD',
    uiName: 'BIT/USD',
    prodReady: true,
    hideInUi: true,
    hasTime: false,
    sqlDate: '2023-04-18',
    coinSymbol: 'BIT',
    fiatDecimals: 5,
    type: ASSETS_TYPES.CRYPTO,
    icon: assets.bit_icon,
    iconPng: assets.bit_icon_png,
    icon2: '',
    icon2Png: '',
    color: '#C1FF3C',
    games: ['lvg-crypto'],
    name: 'BitDAO (BIT)',
    description:
      'BitDAO (BIT) is a collection of builders and stakeholders who hold $BIT tokens and are motivated to make the project a success. Anyone can propose partnerships and protocol upgrades for BitDAO. $BIT token holders may vote on whether to approve or reject these proposals.',
  },
  'CRV/USD': {
    id: 'CRV/USD',
    uiName: 'CRV/USD',
    prodReady: true,
    hideInUi: true,
    hasTime: false,
    sqlDate: '2023-04-18',
    coinSymbol: 'CRV',
    fiatDecimals: 5,
    type: ASSETS_TYPES.CRYPTO,
    icon: assets.crv_icon,
    iconPng: assets.crv_icon_png,
    icon2: '',
    icon2Png: '',
    color: '#FF9F01',
    games: ['lvg-crypto'],
    name: 'Curve DAO Token (CRV)',
    description:
      'Curve DAO Token (CTV) is an Ethereum-based token that powers the ecosystem of Curve.fi, which is a blockchain-based decentralized exchange that uses an automated market maker. Curve DAO Token is the centerpiece of the unique UI that taps into the potential of the decentralized finance market.',
  },
  'OP/USD': {
    id: 'OP/USD',
    uiName: 'OP/USD',
    prodReady: true,
    hideInUi: false,
    hasTime: false,
    sqlDate: '2023-04-18',
    coinSymbol: 'OP',
    fiatDecimals: 5,
    type: ASSETS_TYPES.CRYPTO,
    icon: assets.op_icon,
    iconPng: assets.op_icon_png,
    icon2: '',
    icon2Png: '',
    color: '#FF0620',
    games: ['lvg-crypto'],
    name: 'Optimism (OP)',
    description:
      "Optimism (OP) is a layer two protocol and smart contract platform that aims to enable low-cost and near-instantaneous Ethereum transactions. The OP cryptocurrency powers the Token House, which will be a division of the Optimism Collective alongside the Citizens' House.",
  },
  'MKR/USD': {
    id: 'MKR/USD',
    uiName: 'MKR/USD',
    prodReady: true,
    hideInUi: false,
    hasTime: false,
    sqlDate: '2023-04-18',
    coinSymbol: 'MKR',
    fiatDecimals: 5,
    type: ASSETS_TYPES.CRYPTO,
    icon: assets.mkr_icon,
    iconPng: assets.mkr_icon_png,
    icon2: '',
    icon2Png: '',
    color: '#52AEA0',
    games: ['lvg-crypto'],
    name: 'Maker (MKR)',
    description:
      'Maker (MKR) is an Ethereum token that describes itself as “a utility token, governance token, and recapitalization resource of the Maker system.” The purpose of the Maker system is to generate another Ethereum token, called Dai, that seeks to trade on exchanges at a value of exactly US$1.00.',
  },
  'GMX/USD': {
    id: 'GMX/USD',
    uiName: 'GMX/USD',
    prodReady: true,
    hideInUi: false,
    hasTime: false,
    sqlDate: '2023-04-18',
    coinSymbol: 'GMX',
    fiatDecimals: 5,
    type: ASSETS_TYPES.CRYPTO,
    icon: assets.gmx_icon,
    iconPng: assets.gmx_icon_png,
    icon2: '',
    icon2Png: '',
    color: '#4228F1',
    games: ['lvg-crypto'],
    name: 'GMX (GMX)',
    description:
      "GMX (GMX) is the utility and governance token. Accrues 30% of the platform's generated fees. GLP is the liquidity provider token. Accrues 70% of the platform's generated fees.",
  },
  'SNX/USD': {
    id: 'SNX/USD',
    uiName: 'SNX/USD',
    prodReady: true,
    hideInUi: false,
    hasTime: false,
    sqlDate: '2023-04-18',
    coinSymbol: 'SNX',
    fiatDecimals: 5,
    type: ASSETS_TYPES.CRYPTO,
    icon: assets.snx_icon,
    iconPng: assets.snx_icon_png,
    icon2: '',
    icon2Png: '',
    color: '#00D1FF',
    games: ['lvg-crypto'],
    name: 'Synthetix (SNX)',
    description:
      'Synthetix (SNX) is a decentralized asset insurance protocol, and it allows users to mint, hold, and trade a wide range of derivatives – including commodities, fiat currencies, and even stocks.',
  },
  'ZEC/USD': {
    id: 'ZEC/USD',
    uiName: 'ZEC/USD',
    prodReady: true,
    hideInUi: true,
    hasTime: false,
    sqlDate: '2023-04-18',
    coinSymbol: 'ZEC',
    fiatDecimals: 5,
    type: ASSETS_TYPES.CRYPTO,
    icon: assets.zec_icon,
    iconPng: assets.zec_icon_png,
    icon2: '',
    icon2Png: '',
    color: '#DD9E34',
    games: ['lvg-crypto'],
    name: 'Zcash (ZEC)',
    description:
      'Zcash (ZEC) is a decentralized cryptocurrency focused on privacy and anonymity. It uses the zk-SNARK zero-knowledge proof technology that allows nodes on the network to verify transactions without revealing any sensitive information about those transactions.',
  },
  '1INCH/USD': {
    id: '1INCH/USD',
    uiName: '1INCH/USD',
    prodReady: true,
    hideInUi: true,
    hasTime: false,
    sqlDate: '2023-04-18',
    coinSymbol: '1INCH',
    fiatDecimals: 5,
    type: ASSETS_TYPES.CRYPTO,
    icon: assets.oneInch_icon,
    iconPng: assets.oneInch_icon_png,
    icon2: '',
    icon2Png: '',
    color: '#192E4B',
    games: ['lvg-crypto'],
    name: '1inch Network (1INCH)',
    description:
      "1INCH Network (1INCH) is the utility and governance token of the 1inch protocol and can be used for holding, spending, sending or staking. As the platform's governance token, 1INCH token holders can vote on and propose updates to the 1inch protocol, such as how fees are structured and distributed across platform users.",
  },
  'DYDX/USD': {
    id: 'DYDX/USD',
    uiName: 'DYDX/USD',
    prodReady: true,
    hideInUi: false,
    hasTime: false,
    sqlDate: '2023-04-18',
    coinSymbol: 'DYDX',
    fiatDecimals: 5,
    type: ASSETS_TYPES.CRYPTO,
    icon: assets.dydx_icon,
    iconPng: assets.dydx_icon_png,
    icon2: '',
    icon2Png: '',
    color: '#6966FF',
    games: ['lvg-crypto'],
    name: 'DYDX (dYdX)',
    description:
      'dYdX is a decentralized exchange (DEX) platform that offers perpetual trading options for over 35 popular cryptocurrencies including Bitcoin (BTC), Ether (ETH), Dogecoin (DOGE) and Cardano (ADA).',
  },
  'FTT/USD': {
    id: 'FTT/USD',
    uiName: 'FTT/USD',
    prodReady: false,
    hideInUi: false,
    hasTime: false,
    sqlDate: '',
    coinSymbol: 'FTT',
    fiatDecimals: 5,
    type: ASSETS_TYPES.CRYPTO,
    icon: assets.ftt_icon,
    iconPng: assets.ftt_icon_png,
    icon2: '',
    icon2Png: '',
    color: '#5DC7D9',
    games: ['lvg-crypto'],
    name: 'FTX Token (FTT)',
    description:
      'FTX Token (FTT) was created to provide traders with a way to save on trading fees. When users pay for their trades using FTT, they are given a discount on the fees charged. The more FTT a user holds, the bigger the discount they receive.',
  },
  'BNB/USD': {
    id: 'BNB/USD',
    uiName: 'BNB/USD',
    prodReady: true,
    hideInUi: false,
    hasTime: false,
    sqlDate: '2023-04-04',
    coinSymbol: 'BNB',
    fiatDecimals: 5,
    type: ASSETS_TYPES.CRYPTO,
    icon: assets.bnb_icon,
    iconPng: assets.bnb_icon_png,
    icon2: '',
    icon2Png: '',
    color: '#F3BA2E',
    games: ['lvg-crypto'],
    name: 'Binance (BNB)',
    description:
      'Binance coin (BNB) is the crypto-coin issued by the binance exchange and trades with a BNB symbol. This coin runs on the Ethereum blockchain with standard ERC 20 and is limited to a maximum of 200 million BNB tokens.',
  },
  'SUSHI/USD': {
    id: 'SUSHI/USD',
    uiName: 'SUSHI/USD',
    prodReady: true,
    hideInUi: true,
    hasTime: false,
    sqlDate: '2023-04-18',
    coinSymbol: 'SUSHI',
    fiatDecimals: 5,
    type: ASSETS_TYPES.CRYPTO,
    icon: assets.sushi_icon,
    iconPng: assets.sushi_icon_png,
    icon2: '',
    icon2Png: '',
    color: '#FA52A0',
    games: ['lvg-crypto'],
    name: 'SushiSwap (SUSHI)',
    description:
      "SushiSwap (SUSHI) is an Ethereum token that powers SushiSwap, a decentralized cryptocurrency exchange and automated market maker built on Ethereum. Holders of SUSHI can participate in community governance and stake their tokens to receive a portion of SushiSwap's transaction fees.",
  },
  'DASH/USD': {
    id: 'DASH/USD',
    uiName: 'DASH/USD',
    prodReady: true,
    hideInUi: true,
    hasTime: false,
    sqlDate: '2023-04-18',
    coinSymbol: 'DASH',
    fiatDecimals: 5,
    type: ASSETS_TYPES.CRYPTO,
    icon: assets.dash_icon,
    iconPng: assets.dash_icon_png,
    icon2: '',
    icon2Png: '',
    color: '#008DE4',
    games: ['lvg-crypto'],
    name: 'Dash (DASH)',
    description:
      'Dash (DASH) is an open source cryptocurrency. It is an altcoin that was forked from the Bitcoin protocol. It is also a decentralized autonomous organization (DAO) run by a subset of its users, which are called "masternodes".',
  },
  'ZRX/USD': {
    id: 'ZRX/USD',
    uiName: 'ZRX/USD',
    prodReady: true,
    hideInUi: true,
    hasTime: false,
    sqlDate: '2023-04-18',
    coinSymbol: 'ZRX',
    fiatDecimals: 5,
    type: ASSETS_TYPES.CRYPTO,
    icon: assets.zrx_icon,
    iconPng: assets.zrx_icon_png,
    icon2: '',
    icon2Png: '',
    color: '#000000',
    games: ['lvg-crypto'],
    name: '0x Protocol (ZRX)',
    description:
      "0x Protocol (ZRX) is a peer-to-peer exchange of Ethereum-based tokens. It is often referred to as a decentralized exchange. State channels take transactions offline, thereby reducing costs that are incurred if the transactions take place on Ethereum's network.",
  },
  'BAND/USD': {
    id: 'BAND/USD',
    uiName: 'BAND/USD',
    prodReady: true,
    hideInUi: true,
    hasTime: false,
    sqlDate: '2023-04-18',
    coinSymbol: 'BAND',
    fiatDecimals: 5,
    type: ASSETS_TYPES.CRYPTO,
    icon: assets.band_icon,
    iconPng: assets.band_icon_png,
    icon2: '',
    icon2Png: '',
    color: '#451FE6',
    games: ['lvg-crypto'],
    name: 'Band Protocol (BAND)',
    description:
      'Band Protocol (BAND) is used as collateral by nodes that verify the real-world data that is sent to various blockchains. Nodes fall into two categories: validators and delegators. This two-node structure is common among Cosmos-based Delegated Proof-of-Stake (DPoS) blockchains.',
  },
  'ENS/USD': {
    id: 'ENS/USD',
    uiName: 'ENS/USD',
    prodReady: true,
    hideInUi: true,
    hasTime: false,
    sqlDate: '2023-04-18',
    coinSymbol: 'ENS',
    fiatDecimals: 5,
    type: ASSETS_TYPES.CRYPTO,
    icon: assets.ens_icon,
    iconPng: assets.ens_icon_png,
    icon2: '',
    icon2Png: '',
    color: '#5173FF',
    games: ['lvg-crypto'],
    name: 'Ethereum Name Service (ENS)',
    description:
      'Ethereum Name Service (ENS) is an ERC-20 utility token associated with the Ethereum Name Service, a decentralized naming system built on the Ethereum network. The ENS token was issued via an airdrop to all ENS domain holders, ENS contributors, and the ENS DAO community treasury.',
  },
  'AVAX/USD': {
    id: 'AVAX/USD',
    uiName: 'AVAX/USD',
    prodReady: true,
    hideInUi: false,
    hasTime: false,
    sqlDate: '',
    coinSymbol: 'AVAX',
    fiatDecimals: 5,
    type: ASSETS_TYPES.CRYPTO,
    icon: assets.avax_icon,
    iconPng: assets.avax_icon_png,
    icon2: '',
    icon2Png: '',
    color: '#E84143',
    games: ['lvg-crypto'],
    name: 'Avalanche (AVAX)',
    description:
      'Avalanche (AVAX) is a cryptocurrency and blockchain platform that rivals Ethereum. AVAX is the native token of the Avalanche blockchain, which—like Ethereum—uses smart contracts to support a variety of blockchain projects. The Avalanche blockchain can provide near-instant transaction finality.',
  },
  'GRT/USD': {
    id: 'GRT/USD',
    uiName: 'GRT/USD',
    prodReady: true,
    hideInUi: false,
    hasTime: false,
    sqlDate: '',
    coinSymbol: 'GRT',
    fiatDecimals: 5,
    type: ASSETS_TYPES.CRYPTO,
    icon: assets.grt_icon,
    iconPng: assets.grt_icon_png,
    icon2: '',
    icon2Png: '',
    color: '#6746ED',
    games: ['lvg-crypto'],
    name: 'The Graph (GRT)',
    description:
      'The Graph (GRT) is an Ethereum token that powers The Graph, a decentralized protocol for indexing and querying data from blockchains. Just as Google indexes the web, The Graph indexes blockchain data from networks like Ethereum and Filecoin.',
  },
  'APT/USD': {
    id: 'APT/USD',
    uiName: 'APT/USD',
    prodReady: true,
    hideInUi: false,
    hasTime: false,
    sqlDate: '',
    coinSymbol: 'APT',
    fiatDecimals: 5,
    type: ASSETS_TYPES.CRYPTO,
    icon: assets.apt_icon,
    iconPng: assets.apt_icon_png,
    icon2: '',
    icon2Png: '',
    color: '#000000',
    games: ['lvg-crypto'],
    name: 'Aptos (APT)',
    description:
      'APT is the native cryptocurrency of the Aptos blockchain. It is used for transaction fees, staking, and participating in governance decisions. The Aptos blockchain aims to be a decentralized platform for creating decentralized applications (dApps) and smart contracts, so APT may also be used for these purposes.',
  },
  'CTSI/USD': {
    id: 'CTSI/USD',
    uiName: 'CTSI/USD',
    prodReady: true,
    hideInUi: true,
    hasTime: false,
    sqlDate: '',
    coinSymbol: 'CTSI',
    fiatDecimals: 5,
    type: ASSETS_TYPES.CRYPTO,
    icon: assets.ctsi_icon,
    iconPng: assets.ctsi_icon_png,
    icon2: '',
    icon2Png: '',
    color: '#000000',
    games: ['lvg-crypto'],
    name: 'Cartesi (CTSI)',
    description:
      'The Cartesi cryptocurrency (CTSI) is a multipurpose token that powers the Cartesi Proof of Stake network. It is primarily used for incentivizing Cartesi node operators to engage with the system honestly, as well as for staking and paying transaction fees in the system.',
  },
  BS: {
    id: 'BS',
    uiName: 'BS',
    prodReady: false,
    hideInUi: false,
    hasTime: false,
    sqlDate: '',
    coinSymbol: 'BS',
    fiatDecimals: 5,
    type: ASSETS_TYPES.YOLO_ETF,
    icon: assets.bs_icon,
    iconPng: assets.bs_icon_png,
    icon2: '',
    icon2Png: '',
    color: '#DE0E54',
    games: ['lvg-indexes'],
    name: 'Big Short (BS)',
    description:
      'BS (Big Short) is an experimental ETF which tracks the equal-weighted index of US banks selected by the YOLOREKT committee.',
  },
  iHODL: {
    id: 'iHODL',
    uiName: 'iHODL',
    prodReady: true,
    hideInUi: false,
    hasTime: false,
    sqlDate: '',
    coinSymbol: 'iHODL',
    fiatDecimals: 3,
    type: ASSETS_TYPES.YOLO_ETF,
    icon: assets.ihodl_icon,
    iconPng: assets.ihodl_icon_png,
    icon2: '',
    icon2Png: '',
    color: '#3A9600',
    games: ['lvg-indexes'],
    name: 'yoloETF Blue Chip Index (iHODL)',
    description:
      'yoloETF Blue Chip Index (iHODL) is an experimental ETF which tracks the market cap-weighted index of both <strong>ETH (Ethereum)</strong> and <strong>BTC (Bitcoin)</strong>, created by YOLOREKT.',
  },
  iSHIT: {
    id: 'iSHIT',
    uiName: 'iSHIT',
    prodReady: true,
    hideInUi: false,
    hasTime: false,
    sqlDate: '',
    coinSymbol: 'iSHIT',
    fiatDecimals: 4,
    type: ASSETS_TYPES.YOLO_ETF,
    icon: assets.ishit_icon,
    iconPng: assets.ishit_icon_png,
    icon2: '',
    icon2Png: '',
    color: '#000000',
    games: ['lvg-indexes'],
    name: 'yoloETF Alt Coins Index (iSHIT)',
    description:
      'yoloETF Alt Coins Index (iSHIT) is an experimental ETF which tracks the market cap-weighted index of <strong>SOL (Solana)</strong>, <strong>DOGE (Dogecoin)</strong>, and <strong>TRX (Tron)</strong>, created by YOLOREKT.',
  },
  'BTC/USD': {
    id: 'BTC/USD',
    uiName: 'BTC/USD',
    prodReady: true,
    hideInUi: false,
    hasTime: false,
    sqlDate: '',
    coinSymbol: 'BTC',
    fiatDecimals: 2,
    type: ASSETS_TYPES.CRYPTO,
    icon: assets.btc_icon,
    iconPng: assets.btc_icon_png,
    icon2: '',
    icon2Png: '',
    color: '#F79319',
    games: ['lvg-crypto'],
    name: 'BTC (Bitcoin)',
    description:
      'Bitcoin (BTC) is a cryptocurrency, a virtual currency designed to act as money and a form of payment outside the control of any one person, group, or entity, thus removing the need for third-party involvement in financial transactions. It is rewarded to blockchain miners for the work done to verify transactions and can be purchased on several exchanges.',
  },
  'DOGE/USD': {
    id: 'DOGE/USD',
    uiName: 'DOGE/USD',
    prodReady: true,
    hideInUi: false,
    hasTime: false,
    sqlDate: '',
    coinSymbol: 'DOGE',
    fiatDecimals: 5,
    type: ASSETS_TYPES.CRYPTO,
    icon: assets.doge_icon,
    iconPng: assets.doge_icon_png,
    icon2: '',
    icon2Png: '',
    color: '#C2A633',
    games: ['lvg-crypto'],
    name: 'DOGE (Dogecoin)',
    description:
      "Dogecoin (DOGE) is a peer-to-peer, open-source cryptocurrency. It is considered an altcoin and was launched in December 2013 with the image of a Shiba Inu dog as its logo. Dogecoin's blockchain has merit with its underlying technology derived from Litecoin.",
  },
  'ETH/USD': {
    id: 'ETH/USD',
    uiName: 'ETH/USD',
    prodReady: true,
    hideInUi: false,
    hasTime: false,
    sqlDate: '',
    coinSymbol: 'ETH',
    fiatDecimals: 2,
    type: ASSETS_TYPES.CRYPTO,
    icon: assets.eth_icon,
    iconPng: assets.eth_icon_png,
    icon2: '',
    icon2Png: '',
    color: '#2C86F8',
    games: ['lvg-crypto'],
    name: 'ETH (Ethereum)',
    description:
      'Ethereum is a decentralized blockchain network powered by the Ether token that enables users to make transactions, earn interest on their holdings through staking, use and store nonfungible tokens (NFTs), trade cryptocurrencies, play games, use social media and so much more.',
  },
  'XRP/USD': {
    id: 'XRP/USD',
    uiName: 'XRP/USD',
    prodReady: true,
    hideInUi: false,
    hasTime: false,
    sqlDate: '',
    coinSymbol: 'XRP',
    fiatDecimals: 5,
    type: ASSETS_TYPES.CRYPTO,
    icon: assets.xrp_icon,
    iconPng: assets.xrp_icon_png,
    icon2: '',
    icon2Png: '',
    color: '#008CFF',
    games: ['lvg-crypto'],
    name: 'XRP (Ripple)',
    description:
      'Ripple (XRP) is a real-time, cryptocurrency gross-settlement system, currency exchange and remittance network created by Ripple Labs Inc, a US-based technology company. The company then created the XRP cryptocurrency, which it describes as a “digital asset built for global payments”.',
  },
  'SOL/USD': {
    id: 'SOL/USD',
    uiName: 'SOL/USD',
    prodReady: true,
    hideInUi: false,
    hasTime: false,
    sqlDate: '',
    coinSymbol: 'SOL',
    fiatDecimals: 3,
    type: ASSETS_TYPES.CRYPTO,
    icon: assets.sol_icon,
    iconPng: assets.sol_icon_png,
    icon2: '',
    icon2Png: '',
    color: '#B941F1',
    games: ['lvg-crypto'],
    name: 'SOL (Solana)',
    description:
      'Solana Labs offers an architecture web-scale blockchain. It develops builds and develops crypto apps for decentralized apps and marketplaces.',
  },
  'LTC/USD': {
    id: 'LTC/USD',
    uiName: 'LTC/USD',
    prodReady: true,
    hideInUi: false,
    hasTime: false,
    sqlDate: '',
    coinSymbol: 'LTC',
    fiatDecimals: 5,
    type: ASSETS_TYPES.CRYPTO,
    icon: assets.ltc_icon,
    iconPng: assets.ltc_icon_png,
    icon2: '',
    icon2Png: '',
    color: '#4534FF',
    games: ['lvg-crypto'],
    name: 'LTC (Litecoin)',
    description:
      'Widely considered as the first successful altcoin, Litecoin’s 2011 release inspired countless developers to try to expand the crypto user base by altering Bitcoin’s code and utilizing it to launch different networks. While Litecoin was not the first cryptocurrency to copy Bitcoin’s code and alter its features, it is one of the most significant ones (historically speaking).',
  },
  'LINK/USD': {
    id: 'LINK/USD',
    uiName: 'LINK/USD',
    prodReady: true,
    hideInUi: false,
    hasTime: false,
    sqlDate: '',
    coinSymbol: 'LINK',
    fiatDecimals: 5,
    type: ASSETS_TYPES.CRYPTO,
    icon: assets.link_icon,
    iconPng: assets.link_icon_png,
    icon2: '',
    icon2Png: '',
    color: '#2A5ADA',
    games: ['lvg-crypto'],
    name: 'LINK (Chainlink)',
    description:
      'Chainlink (LINK) is a cryptocurrency and technology platform that enables non-blockchain enterprises to securely connect with blockchain platforms. Chainlink is middleware that connects blockchain-based smart contracts with external data, such as baseball scores or stock prices.',
  },
  'ADA/USD': {
    id: 'ADA/USD',
    uiName: 'ADA/USD',
    prodReady: true,
    hideInUi: false,
    hasTime: false,
    sqlDate: '',
    coinSymbol: 'ADA',
    fiatDecimals: 5,
    type: ASSETS_TYPES.CRYPTO,
    icon: assets.ada_icon,
    iconPng: assets.ada_icon_png,
    icon2: '',
    icon2Png: '',
    color: '#0033AD',
    games: ['lvg-crypto'],
    name: 'ADA (Cardano)',
    description:
      'Cardano (ADA) is a Proof of Stake (PoS) general purpose blockchain project. Known as a “third-generation” blockchain, Cardano has set about solving the common scalability issues plaguing most “second-gen” blockchains (such as Ethereum and it’s ever-increasing gas fees).',
  },
  'TRX/USD': {
    id: 'TRX/USD',
    uiName: 'TRX/USD',
    prodReady: true,
    hideInUi: false,
    hasTime: false,
    sqlDate: '',
    coinSymbol: 'TRX',
    fiatDecimals: 5,
    type: ASSETS_TYPES.CRYPTO,
    icon: assets.trx_icon,
    iconPng: assets.trx_icon_png,
    icon2: '',
    icon2Png: '',
    color: '#FF060A',
    games: ['lvg-crypto'],
    name: 'TRX (TRON)',
    description:
      'Tron is a blockchain-based decentralized digital platform with its own cryptocurrency, called Tronix or TRX. Founded in 2017 by a Singapore non-profit organization, the Tron Foundation, Tron aims to host a global entertainment system for the cost-effective sharing of digital content.',
  },
  'DOT/USD': {
    id: 'DOT/USD',
    uiName: 'DOT/USD',
    prodReady: true,
    hideInUi: false,
    hasTime: false,
    sqlDate: '',
    coinSymbol: 'DOT',
    fiatDecimals: 5,
    type: ASSETS_TYPES.CRYPTO,
    icon: assets.dot_icon,
    iconPng: assets.dot_icon_png,
    icon2: '',
    icon2Png: '',
    color: '#E6007B',
    games: ['lvg-crypto'],
    name: 'DOT (Polkadot)',
    description:
      'Polkadot (DOT) is a cryptocurrency . Polkadot has a current supply of 1,283,028,042.0238583 with 1,156,604,371.7186785 in circulation.',
  },
  'MATIC/USD': {
    id: 'MATIC/USD',
    uiName: 'MATIC/USD',
    prodReady: true,
    hideInUi: false,
    hasTime: false,
    sqlDate: '',
    coinSymbol: 'MATIC',
    fiatDecimals: 5,
    type: ASSETS_TYPES.CRYPTO,
    icon: assets.matic_icon,
    iconPng: assets.matic_icon_png,
    icon2: '',
    icon2Png: '',
    color: '#8247E5',
    games: ['lvg-crypto'],
    name: 'MATIC (Polygon)',
    description:
      "MATIC is Polygon's native cryptocurrency. It is an ERC-20 token, a token created on the Ethereum blockchain. This token is used to govern and secure the Polygon network and pay the network's transaction fees.",
  },
  'APE/USD': {
    id: 'APE/USD',
    uiName: 'APE/USD',
    prodReady: true,
    hideInUi: false,
    hasTime: false,
    sqlDate: '',
    coinSymbol: 'APE',
    fiatDecimals: 5,
    type: ASSETS_TYPES.CRYPTO,
    icon: assets.ape_icon,
    iconPng: assets.ape_icon_png,
    icon2: '',
    icon2Png: '',
    color: '#0052F1',
    games: ['lvg-crypto'],
    name: 'APE (ApeCoin)',
    description:
      'ApeCoin (APE) is a cryptocurrency intended to support the development of a decentralized web3, inspired by one of the most famous and valuable NFT collections: the Bored Ape Yacht Club. APE is a fungible, ERC-20 token built on the Ethereum blockchain.',
  },
  'RLB/USD': {
    id: 'RLB/USD',
    uiName: 'RLB/USD',
    prodReady: true,
    hideInUi: true,
    hasTime: false,
    sqlDate: '',
    coinSymbol: 'RLB',
    fiatDecimals: 5,
    type: ASSETS_TYPES.CRYPTO,
    icon: assets.rlb_icon,
    iconPng: assets.rlb_icon_png,
    icon2: '',
    icon2Png: '',
    color: '#FEA103',
    games: ['lvg-crypto'],
    name: 'RLB (Rollbit Coin)',
    description:
      "Rollbit Coin (RLB) acts as an entry ticket into our lottery, where 20% of the casino's profits are shared between regular lottery prizes and the jackpot (split 70:30). A lottery round happens every 100 Bitcoin blocks, where 100 lucky entrants will win prizes.",
  },
  'ARB/USD': {
    id: 'ARB/USD',
    uiName: 'ARB/USD',
    prodReady: true,
    hideInUi: false,
    hasTime: false,
    sqlDate: '',
    coinSymbol: 'ARB',
    fiatDecimals: 5,
    type: ASSETS_TYPES.CRYPTO,
    icon: assets.arb_icon,
    iconPng: assets.arb_icon_png,
    icon2: '',
    icon2Png: '',
    color: '#26A0F0',
    games: ['lvg-crypto'],
    name: 'ARB (Arbitrum)',
    description:
      'Arbitrum (ARB) is a technology suite designed to scale Ethereum. You can use Arbitrum chains to do all things you do on Ethereum — use Web3 apps, deploy smart contracts, etc., but your transactions will be cheaper and faster.',
  },
  'USDC/USD': {
    id: 'USDC/USD',
    uiName: 'USDC/USD',
    prodReady: true,
    hideInUi: true,
    hasTime: true,
    sqlDate: '',
    coinSymbol: 'USDC',
    fiatDecimals: 5,
    type: ASSETS_TYPES.CRYPTO,
    icon: assets.usdc_icon,
    iconPng: assets.usdc_icon_png,
    icon2: '',
    icon2Png: '',
    color: '#2875CB',
    games: ['lvg-crypto'],
    name: 'USD Coin (USDC)',
    description:
      'USD Coin (USDC) is a stablecoin pegged to the U.S. Dollar. USDC is a stablecoin cryptocurrency designed to maintain a constant value of $1 USD.',
  },
}
